import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Observable, ReplaySubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from './http.service';
import { MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { PermissionHttp } from '../interfaces/permission-http';
@Injectable({ providedIn: 'root' })
export class CommonService {
  language$ = new ReplaySubject<LangChangeEvent>(1);
  translate = this.translateService;
  colorLight = [
    { id: 1, name: 'Xanh' },
    { id: 2, name: 'Đỏ' },
    { id: 3, name: 'Vàng' },
  ]
  actionType = {
    view: {
      id: 1,
      name: "Xem",
    },
    insert: {
      id: 2,
      name: "Thêm",
    },
    update: {
      id: 3,
      name: "Sửa",
    },
    delete: {
      id: 4,
      name: "Xóa",
    },
    export: {
      id: 5,
      name: "Xuất",
    },
  };
  subSystems = [
    { id: 1, name: 'Quản lý hạ tầng đường bộ' },
    { id: 2, name: 'Đèn tín hiệu' }
  ];
  subSystemType = {
    duongbo: { id: 1, name: 'Quản lý hạ tầng đường bộ' },
    dth: { id: 2, name: 'Đèn tín hiệu' }
  }
  public Login: any = {
    View: { 'code': 'Login', 'action': '_view' },
  };
  public Canvas: any = {
    Margin_Width: 100,
    Margin_Height: 200,

  }
  public ALL: any = {
    View: { 'code': 'ALL', 'action': '_view' },
    Export: { 'code': 'ALL', 'action': '_export' },
    Insert: { 'code': 'ALL', 'action': '_insert' },
    Update: { 'code': 'ALL', 'action': '_update' },
    Delete: { 'code': 'ALL', 'action': '_delete' },
  };
  public QTHT: any = {
    View: { 'code': 'QTHT', 'action': '_view' },
    Export: { 'code': 'QTHT', 'action': '_export' },
    Insert: { 'code': 'QTHT', 'action': '_insert' },
    Update: { 'code': 'QTHT', 'action': '_update' },
    Delete: { 'code': 'QTHT', 'action': '_delete' },
  };
  public HSCB: any = {
    View: { 'code': 'HSCB', 'action': '_view' },
    Export: { 'code': 'HSCB', 'action': '_export' },
    Insert: { 'code': 'HSCB', 'action': '_insert' },
    Update: { 'code': 'HSCB', 'action': '_update' },
    Delete: { 'code': 'HSCB', 'action': '_delete' },
  };
  public DHBV: any = {
    View: { 'code': 'DHBV', 'action': '_view' },
    Export: { 'code': 'DHBV', 'action': '_export' },
    Insert: { 'code': 'DHBV', 'action': '_insert' },
    Update: { 'code': 'DHBV', 'action': '_update' },
    Delete: { 'code': 'DHBV', 'action': '_delete' },
  };
  public SCYK: any = {
    View: { 'code': 'SCYK', 'action': '_view' },
    Export: { 'code': 'SCYK', 'action': '_export' },
    Insert: { 'code': 'SCYK', 'action': '_insert' },
    Update: { 'code': 'SCYK', 'action': '_update' },
    Delete: { 'code': 'SCYK', 'action': '_delete' },
  };
  public CLBV: any = {
    View: { 'code': 'CLBV', 'action': '_view' },
    Export: { 'code': 'CLBV', 'action': '_export' },
    Insert: { 'code': 'CLBV', 'action': '_insert' },
    Update: { 'code': 'CLBV', 'action': '_update' },
    Delete: { 'code': 'CLBV', 'action': '_delete' },
  };
  public QLCC: any = {
    View: { 'code': 'QLCC', 'action': '_view' },
    Export: { 'code': 'QLCC', 'action': '_export' },
    Insert: { 'code': 'QLCC', 'action': '_insert' },
    Update: { 'code': 'QLCC', 'action': '_update' },
    Delete: { 'code': 'QLCC', 'action': '_delete' },
  };
  public BCDK: any = {
    View: { 'code': 'BCDK', 'action': '_view' },
    Export: { 'code': 'BCDK', 'action': '_export' },
    Insert: { 'code': 'BCDK', 'action': '_insert' },
    Update: { 'code': 'BCDK', 'action': '_update' },
    Delete: { 'code': 'BCDK', 'action': '_delete' },
  };
  public HT_QuanLyNguoiDung: any = {
    View: { 'code': 'HT_QuanLyNguoiDung', 'action': '_view' },
    Export: { 'code': 'HT_QuanLyNguoiDung', 'action': '_export' },
    Insert: { 'code': 'HT_QuanLyNguoiDung', 'action': '_insert' },
    Update: { 'code': 'HT_QuanLyNguoiDung', 'action': '_update' },
    Delete: { 'code': 'HT_QuanLyNguoiDung', 'action': '_delete' },
  };
  public HT_QuanLyQuyen: any = {
    View: { 'code': 'HT_QuanLyQuyen', 'action': '_view' },
    Export: { 'code': 'HT_QuanLyQuyen', 'action': '_export' },
    Insert: { 'code': 'HT_QuanLyQuyen', 'action': '_insert' },
    Update: { 'code': 'HT_QuanLyQuyen', 'action': '_update' },
    Delete: { 'code': 'HT_QuanLyQuyen', 'action': '_delete' },
  };
  public HT_QuanLyNhomQuyen: any = {
    View: { 'code': 'HT_QuanLyNhomQuyen', 'action': '_view' },
    Export: { 'code': 'HT_QuanLyNhomQuyen', 'action': '_export' },
    Insert: { 'code': 'HT_QuanLyNhomQuyen', 'action': '_insert' },
    Update: { 'code': 'HT_QuanLyNhomQuyen', 'action': '_update' },
    Delete: { 'code': 'HT_QuanLyNhomQuyen', 'action': '_delete' },
  };
  public HT_ThamSoHeThong: any = {
    View: { 'code': 'HT_ThamSoHeThong', 'action': '_view' },
    Export: { 'code': 'HT_ThamSoHeThong', 'action': '_export' },
    Insert: { 'code': 'HT_ThamSoHeThong', 'action': '_insert' },
    Update: { 'code': 'HT_ThamSoHeThong', 'action': '_update' },
    Delete: { 'code': 'HT_ThamSoHeThong', 'action': '_delete' },
  };
  public HT_NhatKyHeThong: any = {
    View: { 'code': 'HT_NhatKyHeThong', 'action': '_view' },
    Export: { 'code': 'HT_NhatKyHeThong', 'action': '_export' },
    Insert: { 'code': 'HT_NhatKyHeThong', 'action': '_insert' },
    Update: { 'code': 'HT_NhatKyHeThong', 'action': '_update' },
    Delete: { 'code': 'HT_NhatKyHeThong', 'action': '_delete' },
  };
  public SC_MucDoTonThuong: any = {
    View: { 'code': 'SC_MucDoTonThuong', 'action': '_view' },
    Export: { 'code': 'SC_MucDoTonThuong', 'action': '_export' },
    Insert: { 'code': 'SC_MucDoTonThuong', 'action': '_insert' },
    Update: { 'code': 'SC_MucDoTonThuong', 'action': '_update' },
    Delete: { 'code': 'SC_MucDoTonThuong', 'action': '_delete' },
  };
  public SC_NghiemTrong: any = {
    View: { 'code': 'SC_NghiemTrong', 'action': '_view' },
    Export: { 'code': 'SC_NghiemTrong', 'action': '_export' },
    Insert: { 'code': 'SC_NghiemTrong', 'action': '_insert' },
    Update: { 'code': 'SC_NghiemTrong', 'action': '_update' },
    Delete: { 'code': 'SC_NghiemTrong', 'action': '_delete' },
  };
  public SC_NhomSuCo: any = {
    View: { 'code': 'SC_NhomSuCo', 'action': '_view' },
    Export: { 'code': 'SC_NhomSuCo', 'action': '_export' },
    Insert: { 'code': 'SC_NhomSuCo', 'action': '_insert' },
    Update: { 'code': 'SC_NhomSuCo', 'action': '_update' },
    Delete: { 'code': 'SC_NhomSuCo', 'action': '_delete' },
  };
  public SC_NguyenNhanGayRa: any = {
    View: { 'code': 'SC_NguyenNhanGayRa', 'action': '_view' },
    Export: { 'code': 'SC_NguyenNhanGayRa', 'action': '_export' },
    Insert: { 'code': 'SC_NguyenNhanGayRa', 'action': '_insert' },
    Update: { 'code': 'SC_NguyenNhanGayRa', 'action': '_update' },
    Delete: { 'code': 'SC_NguyenNhanGayRa', 'action': '_delete' },
  };
  public SC_DoiTuongXayRa: any = {
    View: { 'code': 'SC_DoiTuongXayRa', 'action': '_view' },
    Export: { 'code': 'SC_DoiTuongXayRa', 'action': '_export' },
    Insert: { 'code': 'SC_DoiTuongXayRa', 'action': '_insert' },
    Update: { 'code': 'SC_DoiTuongXayRa', 'action': '_update' },
    Delete: { 'code': 'SC_DoiTuongXayRa', 'action': '_delete' },
  };
  public SC_AnhHuongToChuc: any = {
    View: { 'code': 'SC_AnhHuongToChuc', 'action': '_view' },
    Export: { 'code': 'SC_AnhHuongToChuc', 'action': '_export' },
    Insert: { 'code': 'SC_AnhHuongToChuc', 'action': '_insert' },
    Update: { 'code': 'SC_AnhHuongToChuc', 'action': '_update' },
    Delete: { 'code': 'SC_AnhHuongToChuc', 'action': '_delete' },
  };
  public SC_DoiTuongPhatHien: any = {
    View: { 'code': 'SC_DoiTuongPhatHien', 'action': '_view' },
    Export: { 'code': 'SC_DoiTuongPhatHien', 'action': '_export' },
    Insert: { 'code': 'SC_DoiTuongPhatHien', 'action': '_insert' },
    Update: { 'code': 'SC_DoiTuongPhatHien', 'action': '_update' },
    Delete: { 'code': 'SC_DoiTuongPhatHien', 'action': '_delete' },
  };
  public SC_DanhMucXuatBan: any = {
    View: { 'code': 'SC_DanhMucXuatBan', 'action': '_view' },
    Export: { 'code': 'SC_DanhMucXuatBan', 'action': '_export' },
    Insert: { 'code': 'SC_DanhMucXuatBan', 'action': '_insert' },
    Update: { 'code': 'SC_DanhMucXuatBan', 'action': '_update' },
    Delete: { 'code': 'SC_DanhMucXuatBan', 'action': '_delete' },
  };
  public SC_BaoCao: any = {
    View: { 'code': 'SC_BaoCao', 'action': '_view' },
    Export: { 'code': 'SC_BaoCao', 'action': '_export' },
    Insert: { 'code': 'SC_BaoCao', 'action': '_insert' },
    Update: { 'code': 'SC_BaoCao', 'action': '_update' },
    Delete: { 'code': 'SC_BaoCao', 'action': '_delete' },
  };
  public SC_PhanTichChuyenGia: any = {
    View: { 'code': 'SC_PhanTichChuyenGia', 'action': '_view' },
    Export: { 'code': 'SC_PhanTichChuyenGia', 'action': '_export' },
    Insert: { 'code': 'SC_PhanTichChuyenGia', 'action': '_insert' },
    Update: { 'code': 'SC_PhanTichChuyenGia', 'action': '_update' },
    Delete: { 'code': 'SC_PhanTichChuyenGia', 'action': '_delete' },
  };
  public SC_PhanTichNhanVien: any = {
    View: { 'code': 'SC_PhanTichNhanVien', 'action': '_view' },
    Export: { 'code': 'SC_PhanTichNhanVien', 'action': '_export' },
    Insert: { 'code': 'SC_PhanTichNhanVien', 'action': '_insert' },
    Update: { 'code': 'SC_PhanTichNhanVien', 'action': '_update' },
    Delete: { 'code': 'SC_PhanTichNhanVien', 'action': '_delete' },
  };
  public SC_ThongKeBaoCao: any = {
    View: { 'code': 'SC_ThongKeBaoCao', 'action': '_view' },
    Export: { 'code': 'SC_ThongKeBaoCao', 'action': '_export' },
    Insert: { 'code': 'SC_ThongKeBaoCao', 'action': '_insert' },
    Update: { 'code': 'SC_ThongKeBaoCao', 'action': '_update' },
    Delete: { 'code': 'SC_ThongKeBaoCao', 'action': '_delete' },
  };
  public SC_BanTinAnToan: any = {
    View: { 'code': 'SC_BanTinAnToan', 'action': '_view' },
    Export: { 'code': 'SC_BanTinAnToan', 'action': '_export' },
    Insert: { 'code': 'SC_BanTinAnToan', 'action': '_insert' },
    Update: { 'code': 'SC_BanTinAnToan', 'action': '_update' },
    Delete: { 'code': 'SC_BanTinAnToan', 'action': '_delete' },
  };
  public SC_SuCoQuanTrong: any = {
    View: { 'code': 'SC_SuCoQuanTrong', 'action': '_view' },
    Export: { 'code': 'SC_SuCoQuanTrong', 'action': '_export' },
    Insert: { 'code': 'SC_SuCoQuanTrong', 'action': '_insert' },
    Update: { 'code': 'SC_SuCoQuanTrong', 'action': '_update' },
    Delete: { 'code': 'SC_SuCoQuanTrong', 'action': '_delete' },
  };
  public SC_XuatBanBaoCao: any = {
    View: { 'code': 'SC_XuatBanBaoCao', 'action': '_view' },
    Export: { 'code': 'SC_XuatBanBaoCao', 'action': '_export' },
    Insert: { 'code': 'SC_XuatBanBaoCao', 'action': '_insert' },
    Update: { 'code': 'SC_XuatBanBaoCao', 'action': '_update' },
    Delete: { 'code': 'SC_XuatBanBaoCao', 'action': '_delete' },
  };
  public DH_VB_LoaiVanBan: any = {
    View: { 'code': 'DH_VB_LoaiVanBan', 'action': '_view' },
    Export: { 'code': 'DH_VB_LoaiVanBan', 'action': '_export' },
    Insert: { 'code': 'DH_VB_LoaiVanBan', 'action': '_insert' },
    Update: { 'code': 'DH_VB_LoaiVanBan', 'action': '_update' },
    Delete: { 'code': 'DH_VB_LoaiVanBan', 'action': '_delete' },
  };
  public DH_VB_HinhThucGuiNhan: any = {
    View: { 'code': 'DH_VB_HinhThucGuiNhan', 'action': '_view' },
    Export: { 'code': 'DH_VB_HinhThucGuiNhan', 'action': '_export' },
    Insert: { 'code': 'DH_VB_HinhThucGuiNhan', 'action': '_insert' },
    Update: { 'code': 'DH_VB_HinhThucGuiNhan', 'action': '_update' },
    Delete: { 'code': 'DH_VB_HinhThucGuiNhan', 'action': '_delete' },
  };
  public DH_VB_CoQuanBanHanh: any = {
    View: { 'code': 'DH_VB_CoQuanBanHanh', 'action': '_view' },
    Export: { 'code': 'DH_VB_CoQuanBanHanh', 'action': '_export' },
    Insert: { 'code': 'DH_VB_CoQuanBanHanh', 'action': '_insert' },
    Update: { 'code': 'DH_VB_CoQuanBanHanh', 'action': '_update' },
    Delete: { 'code': 'DH_VB_CoQuanBanHanh', 'action': '_delete' },
  };
  public DH_VB_LinhVucVanBan: any = {
    View: { 'code': 'DH_VB_LinhVucVanBan', 'action': '_view' },
    Export: { 'code': 'DH_VB_LinhVucVanBan', 'action': '_export' },
    Insert: { 'code': 'DH_VB_LinhVucVanBan', 'action': '_insert' },
    Update: { 'code': 'DH_VB_LinhVucVanBan', 'action': '_update' },
    Delete: { 'code': 'DH_VB_LinhVucVanBan', 'action': '_delete' },
  };
  public DH_VB_MucDoKhan: any = {
    View: { 'code': 'DH_VB_MucDoKhan', 'action': '_view' },
    Export: { 'code': 'DH_VB_MucDoKhan', 'action': '_export' },
    Insert: { 'code': 'DH_VB_MucDoKhan', 'action': '_insert' },
    Update: { 'code': 'DH_VB_MucDoKhan', 'action': '_update' },
    Delete: { 'code': 'DH_VB_MucDoKhan', 'action': '_delete' },
  };
  public DH_VB_MucDoMat: any = {
    View: { 'code': 'DH_VB_MucDoMat', 'action': '_view' },
    Export: { 'code': 'DH_VB_MucDoMat', 'action': '_export' },
    Insert: { 'code': 'DH_VB_MucDoMat', 'action': '_insert' },
    Update: { 'code': 'DH_VB_MucDoMat', 'action': '_update' },
    Delete: { 'code': 'DH_VB_MucDoMat', 'action': '_delete' },
  };
  public DH_VB_CongVanDi: any = {
    View: { 'code': 'DH_VB_CongVanDi', 'action': '_view' },
    Export: { 'code': 'DH_VB_CongVanDi', 'action': '_export' },
    Insert: { 'code': 'DH_VB_CongVanDi', 'action': '_insert' },
    Update: { 'code': 'DH_VB_CongVanDi', 'action': '_update' },
    Delete: { 'code': 'DH_VB_CongVanDi', 'action': '_delete' },
  };
  public DH_VB_CongVanDen: any = {
    View: { 'code': 'DH_VB_CongVanDen', 'action': '_view' },
    Export: { 'code': 'DH_VB_CongVanDen', 'action': '_export' },
    Insert: { 'code': 'DH_VB_CongVanDen', 'action': '_insert' },
    Update: { 'code': 'DH_VB_CongVanDen', 'action': '_update' },
    Delete: { 'code': 'DH_VB_CongVanDen', 'action': '_delete' },
  };
  public DH_CV_QuanLyCongViec: any = {
    View: { 'code': 'DH_CV_QuanLyCongViec', 'action': '_view' },
    Export: { 'code': 'DH_CV_QuanLyCongViec', 'action': '_export' },
    Insert: { 'code': 'DH_CV_QuanLyCongViec', 'action': '_insert' },
    Update: { 'code': 'DH_CV_QuanLyCongViec', 'action': '_update' },
    Delete: { 'code': 'DH_CV_QuanLyCongViec', 'action': '_delete' },
  };
  public DH_CongViec: any = {
    View: { 'code': 'DH_CongViec', 'action': '_view' },
    Export: { 'code': 'DH_CongViec', 'action': '_export' },
    Insert: { 'code': 'DH_CongViec', 'action': '_insert' },
    Update: { 'code': 'DH_CongViec', 'action': '_update' },
    Delete: { 'code': 'DH_CongViec', 'action': '_delete' },
  };
  public DH_CV_ThanhVienDuAn: any = {
    View: { 'code': 'DH_CV_ThanhVienDuAn', 'action': '_view' },
    Export: { 'code': 'DH_CV_ThanhVienDuAn', 'action': '_export' },
    Insert: { 'code': 'DH_CV_ThanhVienDuAn', 'action': '_insert' },
    Update: { 'code': 'DH_CV_ThanhVienDuAn', 'action': '_update' },
    Delete: { 'code': 'DH_CV_ThanhVienDuAn', 'action': '_delete' },
  };
  public DH_CV_ThanhPhanDuAn: any = {
    View: { 'code': 'DH_CV_ThanhPhanDuAn', 'action': '_view' },
    Export: { 'code': 'DH_CV_ThanhPhanDuAn', 'action': '_export' },
    Insert: { 'code': 'DH_CV_ThanhPhanDuAn', 'action': '_insert' },
    Update: { 'code': 'DH_CV_ThanhPhanDuAn', 'action': '_update' },
    Delete: { 'code': 'DH_CV_ThanhPhanDuAn', 'action': '_delete' },
  };
  public DH_CV_DoUuTienCongVien: any = {
    View: { 'code': 'DH_CV_DoUuTienCongVien', 'action': '_view' },
    Export: { 'code': 'DH_CV_DoUuTienCongVien', 'action': '_export' },
    Insert: { 'code': 'DH_CV_DoUuTienCongVien', 'action': '_insert' },
    Update: { 'code': 'DH_CV_DoUuTienCongVien', 'action': '_update' },
    Delete: { 'code': 'DH_CV_DoUuTienCongVien', 'action': '_delete' },
  };
  public DH_CV_LoaiDuAn: any = {
    View: { 'code': 'DH_CV_LoaiDuAn', 'action': '_view' },
    Export: { 'code': 'DH_CV_LoaiDuAn', 'action': '_export' },
    Insert: { 'code': 'DH_CV_LoaiDuAn', 'action': '_insert' },
    Update: { 'code': 'DH_CV_LoaiDuAn', 'action': '_update' },
    Delete: { 'code': 'DH_CV_LoaiDuAn', 'action': '_delete' },
  };
  public DH_VB_TaiLieuVanBan: any = {
    View: { 'code': 'DH_VB_TaiLieuVanBan', 'action': '_view' },
    Export: { 'code': 'DH_VB_TaiLieuVanBan', 'action': '_export' },
    Insert: { 'code': 'DH_VB_TaiLieuVanBan', 'action': '_insert' },
    Update: { 'code': 'DH_VB_TaiLieuVanBan', 'action': '_update' },
    Delete: { 'code': 'DH_VB_TaiLieuVanBan', 'action': '_delete' },
  };
  public DH_BC_TinhHinhBenhNhan: any = {
    View: { 'code': 'DH_BC_TinhHinhBenhNhan', 'action': '_view' },
    Export: { 'code': 'DH_BC_TinhHinhBenhNhan', 'action': '_export' },
    Insert: { 'code': 'DH_BC_TinhHinhBenhNhan', 'action': '_insert' },
    Update: { 'code': 'DH_BC_TinhHinhBenhNhan', 'action': '_update' },
    Delete: { 'code': 'DH_BC_TinhHinhBenhNhan', 'action': '_delete' },
  };
  public DH_BC_TinhHinhKhamBenh: any = {
    View: { 'code': 'DH_BC_TinhHinhKhamBenh', 'action': '_view' },
    Export: { 'code': 'DH_BC_TinhHinhKhamBenh', 'action': '_export' },
    Insert: { 'code': 'DH_BC_TinhHinhKhamBenh', 'action': '_insert' },
    Update: { 'code': 'DH_BC_TinhHinhKhamBenh', 'action': '_update' },
    Delete: { 'code': 'DH_BC_TinhHinhKhamBenh', 'action': '_delete' },
  };
  public DH_CV_QuanLyDuAn: any = {
    View: { 'code': 'DH_CV_QuanLyDuAn', 'action': '_view' },
    Export: { 'code': 'DH_CV_QuanLyDuAn', 'action': '_export' },
    Insert: { 'code': 'DH_CV_QuanLyDuAn', 'action': '_insert' },
    Update: { 'code': 'DH_CV_QuanLyDuAn', 'action': '_update' },
    Delete: { 'code': 'DH_CV_QuanLyDuAn', 'action': '_delete' },
  };
  public DH_VanBan: any = {
    View: { 'code': 'DH_VanBan', 'action': '_view' },
    Export: { 'code': 'DH_VanBan', 'action': '_export' },
    Insert: { 'code': 'DH_VanBan', 'action': '_insert' },
    Update: { 'code': 'DH_VanBan', 'action': '_update' },
    Delete: { 'code': 'DH_VanBan', 'action': '_delete' },
  };
  public DH_HSBA: any = {
    View: { 'code': 'DH_HSBA', 'action': '_view' },
    Export: { 'code': 'DH_HSBA', 'action': '_export' },
    Insert: { 'code': 'DH_HSBA', 'action': '_insert' },
    Update: { 'code': 'DH_HSBA', 'action': '_update' },
    Delete: { 'code': 'DH_HSBA', 'action': '_delete' },
  };
  public DH_HS_KetQuaDieuTri: any = {
    View: { 'code': 'DH_HS_KetQuaDieuTri', 'action': '_view' },
    Export: { 'code': 'DH_HS_KetQuaDieuTri', 'action': '_export' },
    Insert: { 'code': 'DH_HS_KetQuaDieuTri', 'action': '_insert' },
    Update: { 'code': 'DH_HS_KetQuaDieuTri', 'action': '_update' },
    Delete: { 'code': 'DH_HS_KetQuaDieuTri', 'action': '_delete' },
  };
  public DH_HS_LoaiHoSo: any = {
    View: { 'code': 'DH_HS_LoaiHoSo', 'action': '_view' },
    Export: { 'code': 'DH_HS_LoaiHoSo', 'action': '_export' },
    Insert: { 'code': 'DH_HS_LoaiHoSo', 'action': '_insert' },
    Update: { 'code': 'DH_HS_LoaiHoSo', 'action': '_update' },
    Delete: { 'code': 'DH_HS_LoaiHoSo', 'action': '_delete' },
  };
  public DH_HS_MauHoSo: any = {
    View: { 'code': 'DH_HS_MauHoSo', 'action': '_view' },
    Export: { 'code': 'DH_HS_MauHoSo', 'action': '_export' },
    Insert: { 'code': 'DH_HS_MauHoSo', 'action': '_insert' },
    Update: { 'code': 'DH_HS_MauHoSo', 'action': '_update' },
    Delete: { 'code': 'DH_HS_MauHoSo', 'action': '_delete' },
  };
  public DH_HS_HoSoBenhAn: any = {
    View: { 'code': 'DH_HS_HoSoBenhAn', 'action': '_view' },
    Export: { 'code': 'DH_HS_HoSoBenhAn', 'action': '_export' },
    Insert: { 'code': 'DH_HS_HoSoBenhAn', 'action': '_insert' },
    Update: { 'code': 'DH_HS_HoSoBenhAn', 'action': '_update' },
    Delete: { 'code': 'DH_HS_HoSoBenhAn', 'action': '_delete' },
  };
  public DH_VB_DonViNgoai: any = {
    View: { 'code': 'DH_VB_DonViNgoai', 'action': '_view' },
    Export: { 'code': 'DH_VB_DonViNgoai', 'action': '_export' },
    Insert: { 'code': 'DH_VB_DonViNgoai', 'action': '_insert' },
    Update: { 'code': 'DH_VB_DonViNgoai', 'action': '_update' },
    Delete: { 'code': 'DH_VB_DonViNgoai', 'action': '_delete' },
  };
  public DH_VB_CanBo: any = {
    View: { 'code': 'DH_VB_CanBo', 'action': '_view' },
    Export: { 'code': 'DH_VB_CanBo', 'action': '_export' },
    Insert: { 'code': 'DH_VB_CanBo', 'action': '_insert' },
    Update: { 'code': 'DH_VB_CanBo', 'action': '_update' },
    Delete: { 'code': 'DH_VB_CanBo', 'action': '_delete' },
  };
  public CC_DangKyNghi: any = {
    View: { 'code': 'CC_DangKyNghi', 'action': '_view' },
    Export: { 'code': 'CC_DangKyNghi', 'action': '_export' },
    Insert: { 'code': 'CC_DangKyNghi', 'action': '_insert' },
    Update: { 'code': 'CC_DangKyNghi', 'action': '_update' },
    Delete: { 'code': 'CC_DangKyNghi', 'action': '_delete' },
  };
  public CC_NgayNghi: any = {
    View: { 'code': 'CC_NgayNghi', 'action': '_view' },
    Export: { 'code': 'CC_NgayNghi', 'action': '_export' },
    Insert: { 'code': 'CC_NgayNghi', 'action': '_insert' },
    Update: { 'code': 'CC_NgayNghi', 'action': '_update' },
    Delete: { 'code': 'CC_NgayNghi', 'action': '_delete' },
  };
  public CC_NgayLamBu: any = {
    View: { 'code': 'CC_NgayLamBu', 'action': '_view' },
    Export: { 'code': 'CC_NgayLamBu', 'action': '_export' },
    Insert: { 'code': 'CC_NgayLamBu', 'action': '_insert' },
    Update: { 'code': 'CC_NgayLamBu', 'action': '_update' },
    Delete: { 'code': 'CC_NgayLamBu', 'action': '_delete' },
  };
  public CC_KyHieuChamCong: any = {
    View: { 'code': 'CC_KyHieuChamCong', 'action': '_view' },
    Export: { 'code': 'CC_KyHieuChamCong', 'action': '_export' },
    Insert: { 'code': 'CC_KyHieuChamCong', 'action': '_insert' },
    Update: { 'code': 'CC_KyHieuChamCong', 'action': '_update' },
    Delete: { 'code': 'CC_KyHieuChamCong', 'action': '_delete' },
  };
  public CC_NhomKyHieuChamCong: any = {
    View: { 'code': 'CC_NhomKyHieuChamCong', 'action': '_view' },
    Export: { 'code': 'CC_NhomKyHieuChamCong', 'action': '_export' },
    Insert: { 'code': 'CC_NhomKyHieuChamCong', 'action': '_insert' },
    Update: { 'code': 'CC_NhomKyHieuChamCong', 'action': '_update' },
    Delete: { 'code': 'CC_NhomKyHieuChamCong', 'action': '_delete' },
  };
  public CC_PhanNhomKyHieuChamCong: any = {
    View: { 'code': 'CC_PhanNhomKyHieuChamCong', 'action': '_view' },
    Export: { 'code': 'CC_PhanNhomKyHieuChamCong', 'action': '_export' },
    Insert: { 'code': 'CC_PhanNhomKyHieuChamCong', 'action': '_insert' },
    Update: { 'code': 'CC_PhanNhomKyHieuChamCong', 'action': '_update' },
    Delete: { 'code': 'CC_PhanNhomKyHieuChamCong', 'action': '_delete' },
  };
  public TKYT_DoiTuong: any = {
    View: { 'code': 'TKYT_DoiTuong', 'action': '_view' },
    Export: { 'code': 'TKYT_DoiTuong', 'action': '_export' },
    Insert: { 'code': 'TKYT_DoiTuong', 'action': '_insert' },
    Update: { 'code': 'TKYT_DoiTuong', 'action': '_update' },
    Delete: { 'code': 'TKYT_DoiTuong', 'action': '_delete' },
  };
  public TKYT_YeuToDichTe: any = {
    View: { 'code': 'TKYT_YeuToDichTe', 'action': '_view' },
    Export: { 'code': 'TKYT_YeuToDichTe', 'action': '_export' },
    Insert: { 'code': 'TKYT_YeuToDichTe', 'action': '_insert' },
    Update: { 'code': 'TKYT_YeuToDichTe', 'action': '_update' },
    Delete: { 'code': 'TKYT_YeuToDichTe', 'action': '_delete' },
  };
  public TKYT_ToKhaiYTe: any = {
    View: { 'code': 'TKYT_ToKhaiYTe', 'action': '_view' },
    Export: { 'code': 'TKYT_ToKhaiYTe', 'action': '_export' },
    Insert: { 'code': 'TKYT_ToKhaiYTe', 'action': '_insert' },
    Update: { 'code': 'TKYT_ToKhaiYTe', 'action': '_update' },
    Delete: { 'code': 'TKYT_ToKhaiYTe', 'action': '_delete' },
  };
  public TKYT_TaoToKhaiYTe: any = {
    View: { 'code': 'TKYT_TaoToKhaiYTe', 'action': '_view' },
    Export: { 'code': 'TKYT_TaoToKhaiYTe', 'action': '_export' },
    Insert: { 'code': 'TKYT_TaoToKhaiYTe', 'action': '_insert' },
    Update: { 'code': 'TKYT_TaoToKhaiYTe', 'action': '_update' },
    Delete: { 'code': 'TKYT_TaoToKhaiYTe', 'action': '_delete' },
  };
  public CLBV_TieuChi_TIeuMuc: any = {
    View: { 'code': 'CLBV_TieuChi_TIeuMuc', 'action': '_view' },
    Export: { 'code': 'CLBV_TieuChi_TIeuMuc', 'action': '_export' },
    Insert: { 'code': 'CLBV_TieuChi_TIeuMuc', 'action': '_insert' },
    Update: { 'code': 'CLBV_TieuChi_TIeuMuc', 'action': '_update' },
    Delete: { 'code': 'CLBV_TieuChi_TIeuMuc', 'action': '_delete' },
  };
  public CLBV_DotKiemTra: any = {
    View: { 'code': 'CLBV_DotKiemTra', 'action': '_view' },
    Export: { 'code': 'CLBV_DotKiemTra', 'action': '_export' },
    Insert: { 'code': 'CLBV_DotKiemTra', 'action': '_insert' },
    Update: { 'code': 'CLBV_DotKiemTra', 'action': '_update' },
    Delete: { 'code': 'CLBV_DotKiemTra', 'action': '_delete' },
  };
  public CLBV_ChamDiem: any = {
    View: { 'code': 'CLBV_ChamDiem', 'action': '_view' },
    Export: { 'code': 'CLBV_ChamDiem', 'action': '_export' },
    Insert: { 'code': 'CLBV_ChamDiem', 'action': '_insert' },
    Update: { 'code': 'CLBV_ChamDiem', 'action': '_update' },
    Delete: { 'code': 'CLBV_ChamDiem', 'action': '_delete' },
  };
  public CLBV_ChiTietKetQuaTieuMuc: any = {
    View: { 'code': 'CLBV_ChiTietKetQuaTieuMuc', 'action': '_view' },
    Export: { 'code': 'CLBV_ChiTietKetQuaTieuMuc', 'action': '_export' },
    Insert: { 'code': 'CLBV_ChiTietKetQuaTieuMuc', 'action': '_insert' },
    Update: { 'code': 'CLBV_ChiTietKetQuaTieuMuc', 'action': '_update' },
    Delete: { 'code': 'CLBV_ChiTietKetQuaTieuMuc', 'action': '_delete' },
  };
  public CLBV_KetQuaKiemTraCacDot: any = {
    View: { 'code': 'CLBV_KetQuaKiemTraCacDot', 'action': '_view' },
    Export: { 'code': 'CLBV_KetQuaKiemTraCacDot', 'action': '_export' },
    Insert: { 'code': 'CLBV_KetQuaKiemTraCacDot', 'action': '_insert' },
    Update: { 'code': 'CLBV_KetQuaKiemTraCacDot', 'action': '_update' },
    Delete: { 'code': 'CLBV_KetQuaKiemTraCacDot', 'action': '_delete' },
  };
  public DM_DanToc: any = {
    View: { 'code': 'DM_DanToc', 'action': '_view' },
    Export: { 'code': 'DM_DanToc', 'action': '_export' },
    Insert: { 'code': 'DM_DanToc', 'action': '_insert' },
    Update: { 'code': 'DM_DanToc', 'action': '_update' },
    Delete: { 'code': 'DM_DanToc', 'action': '_delete' },
  };
  public DM_QuocGia: any = {
    View: { 'code': 'DM_QuocGia', 'action': '_view' },
    Export: { 'code': 'DM_QuocGia', 'action': '_export' },
    Insert: { 'code': 'DM_QuocGia', 'action': '_insert' },
    Update: { 'code': 'DM_QuocGia', 'action': '_update' },
    Delete: { 'code': 'DM_QuocGia', 'action': '_delete' },
  };
  public DM_TonGiao: any = {
    View: { 'code': 'DM_TonGiao', 'action': '_view' },
    Export: { 'code': 'DM_TonGiao', 'action': '_export' },
    Insert: { 'code': 'DM_TonGiao', 'action': '_insert' },
    Update: { 'code': 'DM_TonGiao', 'action': '_update' },
    Delete: { 'code': 'DM_TonGiao', 'action': '_delete' },
  };
  public HSCB_Tinh_Huyen_Xa: any = {
    View: { 'code': 'HSCB_Tinh_Huyen_Xa', 'action': '_view' },
    Export: { 'code': 'HSCB_Tinh_Huyen_Xa', 'action': '_export' },
    Insert: { 'code': 'HSCB_Tinh_Huyen_Xa', 'action': '_insert' },
    Update: { 'code': 'HSCB_Tinh_Huyen_Xa', 'action': '_update' },
    Delete: { 'code': 'HSCB_Tinh_Huyen_Xa', 'action': '_delete' },
  };
  public HSCB_ViTriViecLam: any = {
    View: { 'code': 'HSCB_ViTriViecLam', 'action': '_view' },
    Export: { 'code': 'HSCB_ViTriViecLam', 'action': '_export' },
    Insert: { 'code': 'HSCB_ViTriViecLam', 'action': '_insert' },
    Update: { 'code': 'HSCB_ViTriViecLam', 'action': '_update' },
    Delete: { 'code': 'HSCB_ViTriViecLam', 'action': '_delete' },
  };
  public HSCB_TrinhDoTinHoc: any = {
    View: { 'code': 'HSCB_TrinhDoTinHoc', 'action': '_view' },
    Export: { 'code': 'HSCB_TrinhDoTinHoc', 'action': '_export' },
    Insert: { 'code': 'HSCB_TrinhDoTinHoc', 'action': '_insert' },
    Update: { 'code': 'HSCB_TrinhDoTinHoc', 'action': '_update' },
    Delete: { 'code': 'HSCB_TrinhDoTinHoc', 'action': '_delete' },
  };
  public HSCB_TrinhDoNgoaiNgu: any = {
    View: { 'code': 'HSCB_TrinhDoNgoaiNgu', 'action': '_view' },
    Export: { 'code': 'HSCB_TrinhDoNgoaiNgu', 'action': '_export' },
    Insert: { 'code': 'HSCB_TrinhDoNgoaiNgu', 'action': '_insert' },
    Update: { 'code': 'HSCB_TrinhDoNgoaiNgu', 'action': '_update' },
    Delete: { 'code': 'HSCB_TrinhDoNgoaiNgu', 'action': '_delete' },
  };
  public HSCB_ChuyenNganh: any = {
    View: { 'code': 'HSCB_ChuyenNganh', 'action': '_view' },
    Export: { 'code': 'HSCB_ChuyenNganh', 'action': '_export' },
    Insert: { 'code': 'HSCB_ChuyenNganh', 'action': '_insert' },
    Update: { 'code': 'HSCB_ChuyenNganh', 'action': '_update' },
    Delete: { 'code': 'HSCB_ChuyenNganh', 'action': '_delete' },
  };
  public HSCB_Benh: any = {
    View: { 'code': 'HSCB_Benh', 'action': '_view' },
    Export: { 'code': 'HSCB_Benh', 'action': '_export' },
    Insert: { 'code': 'HSCB_Benh', 'action': '_insert' },
    Update: { 'code': 'HSCB_Benh', 'action': '_update' },
    Delete: { 'code': 'HSCB_Benh', 'action': '_delete' },
  };
  public HSCB_TinhTrangHonNhan: any = {
    View: { 'code': 'HSCB_TinhTrangHonNhan', 'action': '_view' },
    Export: { 'code': 'HSCB_TinhTrangHonNhan', 'action': '_export' },
    Insert: { 'code': 'HSCB_TinhTrangHonNhan', 'action': '_insert' },
    Update: { 'code': 'HSCB_TinhTrangHonNhan', 'action': '_update' },
    Delete: { 'code': 'HSCB_TinhTrangHonNhan', 'action': '_delete' },
  };
  public HSCB_VanBang: any = {
    View: { 'code': 'HSCB_VanBang', 'action': '_view' },
    Export: { 'code': 'HSCB_VanBang', 'action': '_export' },
    Insert: { 'code': 'HSCB_VanBang', 'action': '_insert' },
    Update: { 'code': 'HSCB_VanBang', 'action': '_update' },
    Delete: { 'code': 'HSCB_VanBang', 'action': '_delete' },
  };
  public HSCB_LyLuanChinhTri: any = {
    View: { 'code': 'HSCB_LyLuanChinhTri', 'action': '_view' },
    Export: { 'code': 'HSCB_LyLuanChinhTri', 'action': '_export' },
    Insert: { 'code': 'HSCB_LyLuanChinhTri', 'action': '_insert' },
    Update: { 'code': 'HSCB_LyLuanChinhTri', 'action': '_update' },
    Delete: { 'code': 'HSCB_LyLuanChinhTri', 'action': '_delete' },
  };
  public HSCB_TrinhDoQuanLy: any = {
    View: { 'code': 'HSCB_TrinhDoQuanLy', 'action': '_view' },
    Export: { 'code': 'HSCB_TrinhDoQuanLy', 'action': '_export' },
    Insert: { 'code': 'HSCB_TrinhDoQuanLy', 'action': '_insert' },
    Update: { 'code': 'HSCB_TrinhDoQuanLy', 'action': '_update' },
    Delete: { 'code': 'HSCB_TrinhDoQuanLy', 'action': '_delete' },
  };
  public HSCB_QuanLyBenhVien: any = {
    View: { 'code': 'HSCB_QuanLyBenhVien', 'action': '_view' },
    Export: { 'code': 'HSCB_QuanLyBenhVien', 'action': '_export' },
    Insert: { 'code': 'HSCB_QuanLyBenhVien', 'action': '_insert' },
    Update: { 'code': 'HSCB_QuanLyBenhVien', 'action': '_update' },
    Delete: { 'code': 'HSCB_QuanLyBenhVien', 'action': '_delete' },
  };
  public HSCB_XepLoai: any = {
    View: { 'code': 'HSCB_XepLoai', 'action': '_view' },
    Export: { 'code': 'HSCB_XepLoai', 'action': '_export' },
    Insert: { 'code': 'HSCB_XepLoai', 'action': '_insert' },
    Update: { 'code': 'HSCB_XepLoai', 'action': '_update' },
    Delete: { 'code': 'HSCB_XepLoai', 'action': '_delete' },
  };
  public HSCB_XepLoaiSucKhoe: any = {
    View: { 'code': 'HSCB_XepLoaiSucKhoe', 'action': '_view' },
    Export: { 'code': 'HSCB_XepLoaiSucKhoe', 'action': '_export' },
    Insert: { 'code': 'HSCB_XepLoaiSucKhoe', 'action': '_insert' },
    Update: { 'code': 'HSCB_XepLoaiSucKhoe', 'action': '_update' },
    Delete: { 'code': 'HSCB_XepLoaiSucKhoe', 'action': '_delete' },
  };
  public HSCB_NgoaiNgu: any = {
    View: { 'code': 'HSCB_NgoaiNgu', 'action': '_view' },
    Export: { 'code': 'HSCB_NgoaiNgu', 'action': '_export' },
    Insert: { 'code': 'HSCB_NgoaiNgu', 'action': '_insert' },
    Update: { 'code': 'HSCB_NgoaiNgu', 'action': '_update' },
    Delete: { 'code': 'HSCB_NgoaiNgu', 'action': '_delete' },
  };
  public HSCB_HocHam: any = {
    View: { 'code': 'HSCB_HocHam', 'action': '_view' },
    Export: { 'code': 'HSCB_HocHam', 'action': '_export' },
    Insert: { 'code': 'HSCB_HocHam', 'action': '_insert' },
    Update: { 'code': 'HSCB_HocHam', 'action': '_update' },
    Delete: { 'code': 'HSCB_HocHam', 'action': '_delete' },
  };
  public HSCB_HocVi: any = {
    View: { 'code': 'HSCB_HocVi', 'action': '_view' },
    Export: { 'code': 'HSCB_HocVi', 'action': '_export' },
    Insert: { 'code': 'HSCB_HocVi', 'action': '_insert' },
    Update: { 'code': 'HSCB_HocVi', 'action': '_update' },
    Delete: { 'code': 'HSCB_HocVi', 'action': '_delete' },
  };
  public HSCB_CapDaoTao: any = {
    View: { 'code': 'HSCB_CapDaoTao', 'action': '_view' },
    Export: { 'code': 'HSCB_CapDaoTao', 'action': '_export' },
    Insert: { 'code': 'HSCB_CapDaoTao', 'action': '_insert' },
    Update: { 'code': 'HSCB_CapDaoTao', 'action': '_update' },
    Delete: { 'code': 'HSCB_CapDaoTao', 'action': '_delete' },
  };
  public HSCB_QuanHe: any = {
    View: { 'code': 'HSCB_QuanHe', 'action': '_view' },
    Export: { 'code': 'HSCB_QuanHe', 'action': '_export' },
    Insert: { 'code': 'HSCB_QuanHe', 'action': '_insert' },
    Update: { 'code': 'HSCB_QuanHe', 'action': '_update' },
    Delete: { 'code': 'HSCB_QuanHe', 'action': '_delete' },
  };
  public HSCB_Luong_Co_Ban: any = {
    View: { 'code': 'HSCB_Luong_Co_Ban', 'action': '_view' },
    Export: { 'code': 'HSCB_Luong_Co_Ban', 'action': '_export' },
    Insert: { 'code': 'HSCB_Luong_Co_Ban', 'action': '_insert' },
    Update: { 'code': 'HSCB_Luong_Co_Ban', 'action': '_update' },
    Delete: { 'code': 'HSCB_Luong_Co_Ban', 'action': '_delete' },
  };
  public HSCB_ChucDanh: any = {
    View: { 'code': 'HSCB_ChucDanh', 'action': '_view' },
    Export: { 'code': 'HSCB_ChucDanh', 'action': '_export' },
    Insert: { 'code': 'HSCB_ChucDanh', 'action': '_insert' },
    Update: { 'code': 'HSCB_ChucDanh', 'action': '_update' },
    Delete: { 'code': 'HSCB_ChucDanh', 'action': '_delete' },
  };
  public HSCB_ChucVu: any = {
    View: { 'code': 'HSCB_ChucVu', 'action': '_view' },
    Export: { 'code': 'HSCB_ChucVu', 'action': '_export' },
    Insert: { 'code': 'HSCB_ChucVu', 'action': '_insert' },
    Update: { 'code': 'HSCB_ChucVu', 'action': '_update' },
    Delete: { 'code': 'HSCB_ChucVu', 'action': '_delete' },
  };
  public HSCB_CanBo: any = {
    View: { 'code': 'HSCB_CanBo', 'action': '_view' },
    Export: { 'code': 'HSCB_CanBo', 'action': '_export' },
    Insert: { 'code': 'HSCB_CanBo', 'action': '_insert' },
    Update: { 'code': 'HSCB_CanBo', 'action': '_update' },
    Delete: { 'code': 'HSCB_CanBo', 'action': '_delete' },
  };
  public HSCB_CanBoBangCap: any = {
    View: { 'code': 'HSCB_CanBoBangCap', 'action': '_view' },
    Export: { 'code': 'HSCB_CanBoBangCap', 'action': '_export' },
    Insert: { 'code': 'HSCB_CanBoBangCap', 'action': '_insert' },
    Update: { 'code': 'HSCB_CanBoBangCap', 'action': '_update' },
    Delete: { 'code': 'HSCB_CanBoBangCap', 'action': '_delete' },
  };
  public HSCB_QuaTrinhCongTac: any = {
    View: { 'code': 'HSCB_QuaTrinhCongTac', 'action': '_view' },
    Export: { 'code': 'HSCB_QuaTrinhCongTac', 'action': '_export' },
    Insert: { 'code': 'HSCB_QuaTrinhCongTac', 'action': '_insert' },
    Update: { 'code': 'HSCB_QuaTrinhCongTac', 'action': '_update' },
    Delete: { 'code': 'HSCB_QuaTrinhCongTac', 'action': '_delete' },
  };

  public QLDB: any = {
    View: { 'code': 'QLDB', 'action': '_view' },
    Export: { 'code': 'QLDB', 'action': '_export' },
    Insert: { 'code': 'QLDB', 'action': '_insert' },
    Update: { 'code': 'QLDB', 'action': '_update' },
    Delete: { 'code': 'QLDB', 'action': '_delete' },
  };
  public QLDT: any = {
    View: { 'code': 'QLDT', 'action': '_view' },
    Export: { 'code': 'QLDT', 'action': '_export' },
    Insert: { 'code': 'QLDT', 'action': '_insert' },
    Update: { 'code': 'QLDT', 'action': '_update' },
    Delete: { 'code': 'QLDT', 'action': '_delete' },
  };
  public QLDTH: any = {
    View: { 'code': 'QLDTH', 'action': '_view' },
    Export: { 'code': 'QLDTH', 'action': '_export' },
    Insert: { 'code': 'QLDTH', 'action': '_insert' },
    Update: { 'code': 'QLDTH', 'action': '_update' },
    Delete: { 'code': 'QLDTH', 'action': '_delete' },
  };
  public QLCL: any = {
    View: { 'code': 'QLCL', 'action': '_view' },
    Export: { 'code': 'QLCL', 'action': '_export' },
    Insert: { 'code': 'QLCL', 'action': '_insert' },
    Update: { 'code': 'QLCL', 'action': '_update' },
    Delete: { 'code': 'QLCL', 'action': '_delete' },
  };
  public QLCBT: any = {
    View: { 'code': 'QLCBT', 'action': '_view' },
    Export: { 'code': 'QLCBT', 'action': '_export' },
    Insert: { 'code': 'QLCBT', 'action': '_insert' },
    Update: { 'code': 'QLCBT', 'action': '_update' },
    Delete: { 'code': 'QLCBT', 'action': '_delete' },
  };
  public QLDSCN: any = {
    View: { 'code': 'QLDSCN', 'action': '_view' },
    Export: { 'code': 'QLDSCN', 'action': '_export' },
    Insert: { 'code': 'QLDSCN', 'action': '_insert' },
    Update: { 'code': 'QLDSCN', 'action': '_update' },
    Delete: { 'code': 'QLDSCN', 'action': '_delete' },
  };
  public QLCP: any = {
    View: { 'code': 'QLCP', 'action': '_view' },
    Export: { 'code': 'QLCP', 'action': '_export' },
    Insert: { 'code': 'QLCP', 'action': '_insert' },
    Update: { 'code': 'QLCP', 'action': '_update' },
    Delete: { 'code': 'QLCP', 'action': '_delete' },
  };
  public QLDA: any = {
    View: { 'code': 'QLDA', 'action': '_view' },
    Export: { 'code': 'QLDA', 'action': '_export' },
    Insert: { 'code': 'QLDA', 'action': '_insert' },
    Update: { 'code': 'QLDA', 'action': '_update' },
    Delete: { 'code': 'QLDA', 'action': '_delete' },
  };
  public QLBC: any = {
    View: { 'code': 'QLBC', 'action': '_view' },
    Export: { 'code': 'QLBC', 'action': '_export' },
    Insert: { 'code': 'QLBC', 'action': '_insert' },
    Update: { 'code': 'QLBC', 'action': '_update' },
    Delete: { 'code': 'QLBC', 'action': '_delete' },
  };
  public QLDB_TuyenDuong: any = {
    View: { 'code': 'QLDB_TuyenDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_TuyenDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_TuyenDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_TuyenDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_TuyenDuong', 'action': '_delete' },
  };
  public QLDB_LoaiDuong: any = {
    View: { 'code': 'QLDB_LoaiDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiDuong', 'action': '_delete' },
  };
  public QLDB_CongTrinhDuongBo: any = {
    View: { 'code': 'QLDB_CongTrinhDuongBo', 'action': '_view' },
    Export: { 'code': 'QLDB_CongTrinhDuongBo', 'action': '_export' },
    Insert: { 'code': 'QLDB_CongTrinhDuongBo', 'action': '_insert' },
    Update: { 'code': 'QLDB_CongTrinhDuongBo', 'action': '_update' },
    Delete: { 'code': 'QLDB_CongTrinhDuongBo', 'action': '_delete' },
  };
  public QLDB_LoaiBienBao: any = {
    View: { 'code': 'QLDB_LoaiBienBao', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiBienBao', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiBienBao', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiBienBao', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiBienBao', 'action': '_delete' },
  };
  public QLDB_KetCauMatDuong: any = {
    View: { 'code': 'QLDB_KetCauMatDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_KetCauMatDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_KetCauMatDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_KetCauMatDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_KetCauMatDuong', 'action': '_delete' },
  };
  public QLDB_LoaiCauDuongBo: any = {
    View: { 'code': 'QLDB_LoaiCauDuongBo', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiCauDuongBo', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiCauDuongBo', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiCauDuongBo', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiCauDuongBo', 'action': '_delete' },
  };
  public QLDB_LoaiHam: any = {
    View: { 'code': 'QLDB_LoaiHam', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiHam', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiHam', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiHam', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiHam', 'action': '_delete' },
  };
  public QLDB_LoaiKe: any = {
    View: { 'code': 'QLDB_LoaiKe', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiKe', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiKe', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiKe', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiKe', 'action': '_delete' },
  };
  public QLDTH_DanhMucTaiSanDenTinHieu: any = {
    View: { 'code': 'QLDTH_DanhMucTaiSanDenTinHieu', 'action': '_view' },
    Export: { 'code': 'QLDTH_DanhMucTaiSanDenTinHieu', 'action': '_export' },
    Insert: { 'code': 'QLDTH_DanhMucTaiSanDenTinHieu', 'action': '_insert' },
    Update: { 'code': 'QLDTH_DanhMucTaiSanDenTinHieu', 'action': '_update' },
    Delete: { 'code': 'QLDTH_DanhMucTaiSanDenTinHieu', 'action': '_delete' },
  };
  public QLDTH_CongTrinhDenTinHieu: any = {
    View: { 'code': 'QLDTH_CongTrinhDenTinHieu', 'action': '_view' },
    Export: { 'code': 'QLDTH_CongTrinhDenTinHieu', 'action': '_export' },
    Insert: { 'code': 'QLDTH_CongTrinhDenTinHieu', 'action': '_insert' },
    Update: { 'code': 'QLDTH_CongTrinhDenTinHieu', 'action': '_update' },
    Delete: { 'code': 'QLDTH_CongTrinhDenTinHieu', 'action': '_delete' },
  };
  public TCGT_CongTrinhToChucGiaoThong: any = {
    View: { 'code': 'TCGT_CongTrinhToChucGiaoThong', 'action': '_view' },
    Export: { 'code': 'TCGT_CongTrinhToChucGiaoThong', 'action': '_export' },
    Insert: { 'code': 'TCGT_CongTrinhToChucGiaoThong', 'action': '_insert' },
    Update: { 'code': 'TCGT_CongTrinhToChucGiaoThong', 'action': '_update' },
    Delete: { 'code': 'TCGT_CongTrinhToChucGiaoThong', 'action': '_delete' },
  };

  public TCGT_DanhMuc: any = {
    View: { 'code': 'TCGT_DanhMuc', 'action': '_view' },
    Export: { 'code': 'TCGT_DanhMuc', 'action': '_export' },
    Insert: { 'code': 'TCGT_DanhMuc', 'action': '_insert' },
    Update: { 'code': 'TCGT_DanhMuc', 'action': '_update' },
    Delete: { 'code': 'TCGT_DanhMuc', 'action': '_delete' },
  };
  public QLDB_BienBao: any = {
    View: { 'code': 'QLDB_BienBao', 'action': '_view' },
    Export: { 'code': 'QLDB_BienBao', 'action': '_export' },
    Insert: { 'code': 'QLDB_BienBao', 'action': '_insert' },
    Update: { 'code': 'QLDB_BienBao', 'action': '_update' },
    Delete: { 'code': 'QLDB_BienBao', 'action': '_delete' },
  };
  public QLDB_DanhMuc: any = {
    View: { 'code': 'QLDB_DanhMuc', 'action': '_view' },
    Export: { 'code': 'QLDB_DanhMuc', 'action': '_export' },
    Insert: { 'code': 'QLDB_DanhMuc', 'action': '_insert' },
    Update: { 'code': 'QLDB_DanhMuc', 'action': '_update' },
    Delete: { 'code': 'QLDB_DanhMuc', 'action': '_delete' },
  };
  public QLDTH_QuanLyNut: any = {
    View: { 'code': 'QLDTH_QuanLyNut', 'action': '_view' },
    Export: { 'code': 'QLDTH_QuanLyNut', 'action': '_export' },
    Insert: { 'code': 'QLDTH_QuanLyNut', 'action': '_insert' },
    Update: { 'code': 'QLDTH_QuanLyNut', 'action': '_update' },
    Delete: { 'code': 'QLDTH_QuanLyNut', 'action': '_delete' },
  };
  public QLDTH_DanhMucCotDenTinHieu: any = {
    View: { 'code': 'QLDTH_DanhMucCotDenTinHieu', 'action': '_view' },
    Export: { 'code': 'QLDTH_DanhMucCotDenTinHieu', 'action': '_export' },
    Insert: { 'code': 'QLDTH_DanhMucCotDenTinHieu', 'action': '_insert' },
    Update: { 'code': 'QLDTH_DanhMucCotDenTinHieu', 'action': '_update' },
    Delete: { 'code': 'QLDTH_DanhMucCotDenTinHieu', 'action': '_delete' },
  };
  public QLDT_CongTrinhDuongThuy: any = {
    View: { 'code': 'QLDT_CongTrinhDuongThuy', 'action': '_view' },
    Export: { 'code': 'QLDT_CongTrinhDuongThuy', 'action': '_export' },
    Insert: { 'code': 'QLDT_CongTrinhDuongThuy', 'action': '_insert' },
    Update: { 'code': 'QLDT_CongTrinhDuongThuy', 'action': '_update' },
    Delete: { 'code': 'QLDT_CongTrinhDuongThuy', 'action': '_delete' },
  };
  public QLDTH_DanhMuc: any = {
    View: { 'code': 'QLDTH_DanhMuc', 'action': '_view' },
    Export: { 'code': 'QLDTH_DanhMuc', 'action': '_export' },
    Insert: { 'code': 'QLDTH_DanhMuc', 'action': '_insert' },
    Update: { 'code': 'QLDTH_DanhMuc', 'action': '_update' },
    Delete: { 'code': 'QLDTH_DanhMuc', 'action': '_delete' },
  };
  public QLDB_ThongKe: any = {
    View: { 'code': 'QLDB_ThongKe', 'action': '_view' },
    Export: { 'code': 'QLDB_ThongKe', 'action': '_export' },
    Insert: { 'code': 'QLDB_ThongKe', 'action': '_insert' },
    Update: { 'code': 'QLDB_ThongKe', 'action': '_update' },
    Delete: { 'code': 'QLDB_ThongKe', 'action': '_delete' },
  };
  public QLDTH_ThongKe: any = {
    View: { 'code': 'QLDTH_ThongKe', 'action': '_view' },
    Export: { 'code': 'QLDTH_ThongKe', 'action': '_export' },
    Insert: { 'code': 'QLDTH_ThongKe', 'action': '_insert' },
    Update: { 'code': 'QLDTH_ThongKe', 'action': '_update' },
    Delete: { 'code': 'QLDTH_ThongKe', 'action': '_delete' },
  };
  public TCGT_ThongKe: any = {
    View: { 'code': 'TCGT_ThongKe', 'action': '_view' },
    Export: { 'code': 'TCGT_ThongKe', 'action': '_export' },
    Insert: { 'code': 'TCGT_ThongKe', 'action': '_insert' },
    Update: { 'code': 'TCGT_ThongKe', 'action': '_update' },
    Delete: { 'code': 'TCGT_ThongKe', 'action': '_delete' },
  };
  public TCGT_BaoCao: any = {
    View: { 'code': 'TCGT_BaoCao', 'action': '_view' },
    Export: { 'code': 'TCGT_BaoCao', 'action': '_export' },
    Insert: { 'code': 'TCGT_BaoCao', 'action': '_insert' },
    Update: { 'code': 'TCGT_BaoCao', 'action': '_update' },
    Delete: { 'code': 'TCGT_BaoCao', 'action': '_delete' },
  };
  public QLDTH_BaoCao: any = {
    View: { 'code': 'QLDTH_BaoCao', 'action': '_view' },
    Export: { 'code': 'QLDTH_BaoCao', 'action': '_export' },
    Insert: { 'code': 'QLDTH_BaoCao', 'action': '_insert' },
    Update: { 'code': 'QLDTH_BaoCao', 'action': '_update' },
    Delete: { 'code': 'QLDTH_BaoCao', 'action': '_delete' },
  };
  public QLDB_BaoCao: any = {
    View: { 'code': 'QLDB_BaoCao', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCao', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCao', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCao', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCao', 'action': '_delete' },
  };
  public QLDB_CauHinhMau: any = {
    View: { 'code': 'QLDB_CauHinhMau', 'action': '_view' },
    Export: { 'code': 'QLDB_CauHinhMau', 'action': '_export' },
    Insert: { 'code': 'QLDB_CauHinhMau', 'action': '_insert' },
    Update: { 'code': 'QLDB_CauHinhMau', 'action': '_update' },
    Delete: { 'code': 'QLDB_CauHinhMau', 'action': '_delete' },
  };
  public QLDB_DonViQuanLyChild: any = {
    View: { 'code': 'QLDB_DonViQuanLyChild', 'action': '_view' },
    Export: { 'code': 'QLDB_DonViQuanLyChild', 'action': '_export' },
    Insert: { 'code': 'QLDB_DonViQuanLyChild', 'action': '_insert' },
    Update: { 'code': 'QLDB_DonViQuanLyChild', 'action': '_update' },
    Delete: { 'code': 'QLDB_DonViQuanLyChild', 'action': '_delete' },
  };
  public TCGT_BaoCao_SoLuongBienBao: any = {
    View: { 'code': 'TCGT_BaoCao_SoLuongBienBao', 'action': '_view' },
    Export: { 'code': 'TCGT_BaoCao_SoLuongBienBao', 'action': '_export' },
    Insert: { 'code': 'TCGT_BaoCao_SoLuongBienBao', 'action': '_insert' },
    Update: { 'code': 'TCGT_BaoCao_SoLuongBienBao', 'action': '_update' },
    Delete: { 'code': 'TCGT_BaoCao_SoLuongBienBao', 'action': '_delete' },
  };
  public QLDB_BaoCao_KhoiLuongCauDuong: any = {
    View: { 'code': 'QLDB_BaoCao_KhoiLuongCauDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCao_KhoiLuongCauDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCao_KhoiLuongCauDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCao_KhoiLuongCauDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCao_KhoiLuongCauDuong', 'action': '_delete' },
  };
  public QLDTDB_KeHoachDuKien: any = {
    View: { 'code': 'QLDTDB_KeHoachDuKien', 'action': '_view' },
    Export: { 'code': 'QLDTDB_KeHoachDuKien', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_KeHoachDuKien', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_KeHoachDuKien', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_KeHoachDuKien', 'action': '_delete' },
  };
  public QLDTDB_BaoCaoLichSuDuyTu: any = {
    View: { 'code': 'QLDTDB_BaoCaoLichSuDuyTu', 'action': '_view' },
    Export: { 'code': 'QLDTDB_BaoCaoLichSuDuyTu', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_BaoCaoLichSuDuyTu', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_BaoCaoLichSuDuyTu', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_BaoCaoLichSuDuyTu', 'action': '_delete' },
  };
  public TCGT_BaoCao_ThongKeSonDeoNhiet: any = {
    View: { 'code': 'TCGT_BaoCao_ThongKeSonDeoNhiet', 'action': '_view' },
    Export: { 'code': 'TCGT_BaoCao_ThongKeSonDeoNhiet', 'action': '_export' },
    Insert: { 'code': 'TCGT_BaoCao_ThongKeSonDeoNhiet', 'action': '_insert' },
    Update: { 'code': 'TCGT_BaoCao_ThongKeSonDeoNhiet', 'action': '_update' },
    Delete: { 'code': 'TCGT_BaoCao_ThongKeSonDeoNhiet', 'action': '_delete' },
  };
  public QLDB_HangMucCongViec: any = {
    View: { 'code': 'QLDB_HangMucCongViec', 'action': '_view' },
    Export: { 'code': 'QLDB_HangMucCongViec', 'action': '_export' },
    Insert: { 'code': 'QLDB_HangMucCongViec', 'action': '_insert' },
    Update: { 'code': 'QLDB_HangMucCongViec', 'action': '_update' },
    Delete: { 'code': 'QLDB_HangMucCongViec', 'action': '_delete' },
  };
  public QLTC_KhoiLuongNghiemThu: any = {
    View: { 'code': 'QLTC_KhoiLuongNghiemThu', 'action': '_view' },
    Export: { 'code': 'QLTC_KhoiLuongNghiemThu', 'action': '_export' },
    Insert: { 'code': 'QLTC_KhoiLuongNghiemThu', 'action': '_insert' },
    Update: { 'code': 'QLTC_KhoiLuongNghiemThu', 'action': '_update' },
    Delete: { 'code': 'QLTC_KhoiLuongNghiemThu', 'action': '_delete' },
  };
  public QLDB_KhoiLuongDuyTuGiamSat: any = {
    View: { 'code': 'QLDB_KhoiLuongDuyTuGiamSat', 'action': '_view' },
    Export: { 'code': 'QLDB_KhoiLuongDuyTuGiamSat', 'action': '_export' },
    Insert: { 'code': 'QLDB_KhoiLuongDuyTuGiamSat', 'action': '_insert' },
    Update: { 'code': 'QLDB_KhoiLuongDuyTuGiamSat', 'action': '_update' },
    Delete: { 'code': 'QLDB_KhoiLuongDuyTuGiamSat', 'action': '_delete' },
  };
  public QLDB_LoaiDoanDuong: any = {
    View: { 'code': 'QLDB_LoaiDoanDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiDoanDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiDoanDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiDoanDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiDoanDuong', 'action': '_delete' },
  };
  public QLDB_LoaiSonNhiet: any = {
    View: { 'code': 'QLDB_LoaiSonNhiet', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiSonNhiet', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiSonNhiet', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiSonNhiet', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiSonNhiet', 'action': '_delete' },
  };
  public QLDB_BinhDoDuoiThang: any = {
    View: { 'code': 'QLDB_BinhDoDuoiThang', 'action': '_view' },
    Export: { 'code': 'QLDB_BinhDoDuoiThang', 'action': '_export' },
    Insert: { 'code': 'QLDB_BinhDoDuoiThang', 'action': '_insert' },
    Update: { 'code': 'QLDB_BinhDoDuoiThang', 'action': '_update' },
    Delete: { 'code': 'QLDB_BinhDoDuoiThang', 'action': '_delete' },
  };
  public QLDTDB_ThamMatDuong: any = {
    View: { 'code': 'QLDTDB_ThamMatDuong', 'action': '_view' },
    Export: { 'code': 'QLDTDB_ThamMatDuong', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_ThamMatDuong', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_ThamMatDuong', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_ThamMatDuong', 'action': '_delete' },
  };
  public QLDTDB_KhoiLuongDuyTuKeHoach: any = {
    View: { 'code': 'QLDTDB_KhoiLuongDuyTuKeHoach', 'action': '_view' },
    Export: { 'code': 'QLDTDB_KhoiLuongDuyTuKeHoach', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_KhoiLuongDuyTuKeHoach', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_KhoiLuongDuyTuKeHoach', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_KhoiLuongDuyTuKeHoach', 'action': '_delete' },
  };
  public QLDB_BinhDo: any = {
    View: { 'code': 'QLDB_BinhDo', 'action': '_view' },
    Export: { 'code': 'QLDB_BinhDo', 'action': '_export' },
    Insert: { 'code': 'QLDB_BinhDo', 'action': '_insert' },
    Update: { 'code': 'QLDB_BinhDo', 'action': '_update' },
    Delete: { 'code': 'QLDB_BinhDo', 'action': '_delete' },
  };
  public QLDB_LoaiHoLan: any = {
    View: { 'code': 'QLDB_LoaiHoLan', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiHoLan', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiHoLan', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiHoLan', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiHoLan', 'action': '_delete' },
  };
  public QLDB_LoaiCocTieu: any = {
    View: { 'code': 'QLDB_LoaiCocTieu', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiCocTieu', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiCocTieu', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiCocTieu', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiCocTieu', 'action': '_delete' },
  };
  public DonVi_CoCauToChuc: any = {
    View: { 'code': 'DonVi_CoCauToChuc', 'action': '_view' },
    Export: { 'code': 'DonVi_CoCauToChuc', 'action': '_export' },
    Insert: { 'code': 'DonVi_CoCauToChuc', 'action': '_insert' },
    Update: { 'code': 'DonVi_CoCauToChuc', 'action': '_update' },
    Delete: { 'code': 'DonVi_CoCauToChuc', 'action': '_delete' },
  };
  public QLDB_TinhTrang: any = {
    View: { 'code': 'QLDB_TinhTrang', 'action': '_view' },
    Export: { 'code': 'QLDB_TinhTrang', 'action': '_export' },
    Insert: { 'code': 'QLDB_TinhTrang', 'action': '_insert' },
    Update: { 'code': 'QLDB_TinhTrang', 'action': '_update' },
    Delete: { 'code': 'QLDB_TinhTrang', 'action': '_delete' },
  };
  public QLDTH_QuanLyCot: any = {
    View: { 'code': 'QLDTH_QuanLyCot', 'action': '_view' },
    Export: { 'code': 'QLDTH_QuanLyCot', 'action': '_export' },
    Insert: { 'code': 'QLDTH_QuanLyCot', 'action': '_insert' },
    Update: { 'code': 'QLDTH_QuanLyCot', 'action': '_update' },
    Delete: { 'code': 'QLDTH_QuanLyCot', 'action': '_delete' },
  };
  public QLDB_LoaiDaiPhanCach: any = {
    View: { 'code': 'QLDB_LoaiDaiPhanCach', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiDaiPhanCach', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiDaiPhanCach', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiDaiPhanCach', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiDaiPhanCach', 'action': '_delete' },
  };
  public QLDB_ChungLoaiBoVia: any = {
    View: { 'code': 'QLDB_ChungLoaiBoVia', 'action': '_view' },
    Export: { 'code': 'QLDB_ChungLoaiBoVia', 'action': '_export' },
    Insert: { 'code': 'QLDB_ChungLoaiBoVia', 'action': '_insert' },
    Update: { 'code': 'QLDB_ChungLoaiBoVia', 'action': '_update' },
    Delete: { 'code': 'QLDB_ChungLoaiBoVia', 'action': '_delete' },
  };
  public QLDB_HienTrangDaiPhanCach: any = {
    View: { 'code': 'QLDB_HienTrangDaiPhanCach', 'action': '_view' },
    Export: { 'code': 'QLDB_HienTrangDaiPhanCach', 'action': '_export' },
    Insert: { 'code': 'QLDB_HienTrangDaiPhanCach', 'action': '_insert' },
    Update: { 'code': 'QLDB_HienTrangDaiPhanCach', 'action': '_update' },
    Delete: { 'code': 'QLDB_HienTrangDaiPhanCach', 'action': '_delete' },
  };
  public QLDB_LoaiRaoChan: any = {
    View: { 'code': 'QLDB_LoaiRaoChan', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiRaoChan', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiRaoChan', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiRaoChan', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiRaoChan', 'action': '_delete' },
  };
  public QLDB_DaiPhanCach: any = {
    View: { 'code': 'QLDB_DaiPhanCach', 'action': '_view' },
    Export: { 'code': 'QLDB_DaiPhanCach', 'action': '_export' },
    Insert: { 'code': 'QLDB_DaiPhanCach', 'action': '_insert' },
    Update: { 'code': 'QLDB_DaiPhanCach', 'action': '_update' },
    Delete: { 'code': 'QLDB_DaiPhanCach', 'action': '_delete' },
  };
  public QLDB_LoaiDaoGiaoThong: any = {
    View: { 'code': 'QLDB_LoaiDaoGiaoThong', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiDaoGiaoThong', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiDaoGiaoThong', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiDaoGiaoThong', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiDaoGiaoThong', 'action': '_delete' },
  };
  public QLDB_DaoGiaoThong: any = {
    View: { 'code': 'QLDB_DaoGiaoThong', 'action': '_view' },
    Export: { 'code': 'QLDB_DaoGiaoThong', 'action': '_export' },
    Insert: { 'code': 'QLDB_DaoGiaoThong', 'action': '_insert' },
    Update: { 'code': 'QLDB_DaoGiaoThong', 'action': '_update' },
    Delete: { 'code': 'QLDB_DaoGiaoThong', 'action': '_delete' },
  };
  public QLDB_LoaiRaoChan_DuongSat: any = {
    View: { 'code': 'QLDB_LoaiRaoChan_DuongSat', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiRaoChan_DuongSat', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiRaoChan_DuongSat', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiRaoChan_DuongSat', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiRaoChan_DuongSat', 'action': '_delete' },
  };
  public QLDB_HinhThucGiaoCat: any = {
    View: { 'code': 'QLDB_HinhThucGiaoCat', 'action': '_view' },
    Export: { 'code': 'QLDB_HinhThucGiaoCat', 'action': '_export' },
    Insert: { 'code': 'QLDB_HinhThucGiaoCat', 'action': '_insert' },
    Update: { 'code': 'QLDB_HinhThucGiaoCat', 'action': '_update' },
    Delete: { 'code': 'QLDB_HinhThucGiaoCat', 'action': '_delete' },
  };
  public QLDB_GiaoCatDuongSat: any = {
    View: { 'code': 'QLDB_GiaoCatDuongSat', 'action': '_view' },
    Export: { 'code': 'QLDB_GiaoCatDuongSat', 'action': '_export' },
    Insert: { 'code': 'QLDB_GiaoCatDuongSat', 'action': '_insert' },
    Update: { 'code': 'QLDB_GiaoCatDuongSat', 'action': '_update' },
    Delete: { 'code': 'QLDB_GiaoCatDuongSat', 'action': '_delete' },
  };
  public QLDB_BaoCaoBienBao: any = {
    View: { 'code': 'QLDB_BaoCaoBienBao', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoBienBao', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoBienBao', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoBienBao', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoBienBao', 'action': '_delete' },
  };
  public QLDB_BaoCaoCauDuongBo: any = {
    View: { 'code': 'QLDB_BaoCaoCauDuongBo', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoCauDuongBo', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoCauDuongBo', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoCauDuongBo', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoCauDuongBo', 'action': '_delete' },
  };
  public QLDB_BaoCaoHoGa: any = {
    View: { 'code': 'QLDB_BaoCaoHoGa', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoHoGa', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoHoGa', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoHoGa', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoHoGa', 'action': '_delete' },
  };
  public QLDB_BaoCaoCong: any = {
    View: { 'code': 'QLDB_BaoCaoCong', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoCong', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoCong', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoCong', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoCong', 'action': '_delete' },
  };
  public QLDB_LoaiCong: any = {
    View: { 'code': 'QLDB_LoaiCong', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiCong', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiCong', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiCong', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiCong', 'action': '_delete' },
  };
  public QLDB_BaoCaoHam: any = {
    View: { 'code': 'QLDB_BaoCaoHam', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoHam', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoHam', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoHam', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoHam', 'action': '_delete' },
  };
  public QLDB_BaoCaoKe: any = {
    View: { 'code': 'QLDB_BaoCaoKe', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoKe', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoKe', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoKe', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoKe', 'action': '_delete' },
  };
  public QLDB_GiaLongMon: any = {
    View: { 'code': 'QLDB_GiaLongMon', 'action': '_view' },
    Export: { 'code': 'QLDB_GiaLongMon', 'action': '_export' },
    Insert: { 'code': 'QLDB_GiaLongMon', 'action': '_insert' },
    Update: { 'code': 'QLDB_GiaLongMon', 'action': '_update' },
    Delete: { 'code': 'QLDB_GiaLongMon', 'action': '_delete' },
  };
  public QLDB_BaoCaoRanhNuoc: any = {
    View: { 'code': 'QLDB_BaoCaoRanhNuoc', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoRanhNuoc', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoRanhNuoc', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoRanhNuoc', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoRanhNuoc', 'action': '_delete' },
  };
  public QLDB_BaoCaoHoLan: any = {
    View: { 'code': 'QLDB_BaoCaoHoLan', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoHoLan', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoHoLan', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoHoLan', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoHoLan', 'action': '_delete' },
  };
  public QLDB_BaoCaoDoanCocTieu: any = {
    View: { 'code': 'QLDB_BaoCaoDoanCocTieu', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoDoanCocTieu', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoDoanCocTieu', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoDoanCocTieu', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoDoanCocTieu', 'action': '_delete' },
  };
  public QLDB_BaoCaoDoanDuong: any = {
    View: { 'code': 'QLDB_BaoCaoDoanDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoDoanDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoDoanDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoDoanDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoDoanDuong', 'action': '_delete' },
  };
  public QLDB_BaoCaoCotKm: any = {
    View: { 'code': 'QLDB_BaoCaoCotKm', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoCotKm', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoCotKm', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoCotKm', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoCotKm', 'action': '_delete' },
  };
  public QLDB_BaoCaoCotH: any = {
    View: { 'code': 'QLDB_BaoCaoCotH', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoCotH', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoCotH', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoCotH', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoCotH', 'action': '_delete' },
  };
  public QLDB_BaoCaoSonDeoNhiet: any = {
    View: { 'code': 'QLDB_BaoCaoSonDeoNhiet', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoSonDeoNhiet', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoSonDeoNhiet', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoSonDeoNhiet', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoSonDeoNhiet', 'action': '_delete' },
  };
  public QLDB_BaoCaoLoiRe: any = {
    View: { 'code': 'QLDB_BaoCaoLoiRe', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoLoiRe', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoLoiRe', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoLoiRe', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoLoiRe', 'action': '_delete' },
  };
  public QLDB_BaoCaoDaiPhanCach: any = {
    View: { 'code': 'QLDB_BaoCaoDaiPhanCach', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoDaiPhanCach', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoDaiPhanCach', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoDaiPhanCach', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoDaiPhanCach', 'action': '_delete' },
  };
  public QLDB_BaoCaoGiaLongMon: any = {
    View: { 'code': 'QLDB_BaoCaoGiaLongMon', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoGiaLongMon', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoGiaLongMon', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoGiaLongMon', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoGiaLongMon', 'action': '_delete' },
  };
  public QLDB_BaoCaoGiaoCatDuongSat: any = {
    View: { 'code': 'QLDB_BaoCaoGiaoCatDuongSat', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoGiaoCatDuongSat', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoGiaoCatDuongSat', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoGiaoCatDuongSat', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoGiaoCatDuongSat', 'action': '_delete' },
  };
  public QLDB_BaoCaoDinhPhanQuang: any = {
    View: { 'code': 'QLDB_BaoCaoDinhPhanQuang', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoDinhPhanQuang', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoDinhPhanQuang', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoDinhPhanQuang', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoDinhPhanQuang', 'action': '_delete' },
  };
  public QLDB_QuanLyBienBao: any = {
    View: { 'code': 'QLDB_QuanLyBienBao', 'action': '_view' },
    Export: { 'code': 'QLDB_QuanLyBienBao', 'action': '_export' },
    Insert: { 'code': 'QLDB_QuanLyBienBao', 'action': '_insert' },
    Update: { 'code': 'QLDB_QuanLyBienBao', 'action': '_update' },
    Delete: { 'code': 'QLDB_QuanLyBienBao', 'action': '_delete' },
  };
  public QLDB_ThamMatDuong: any = {
    View: { 'code': 'QLDB_ThamMatDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_ThamMatDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_ThamMatDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_ThamMatDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_ThamMatDuong', 'action': '_delete' },
  };
  public QLDB_VachSon: any = {
    View: { 'code': 'QLDB_VachSon', 'action': '_view' },
    Export: { 'code': 'QLDB_VachSon', 'action': '_export' },
    Insert: { 'code': 'QLDB_VachSon', 'action': '_insert' },
    Update: { 'code': 'QLDB_VachSon', 'action': '_update' },
    Delete: { 'code': 'QLDB_VachSon', 'action': '_delete' },
  };
  public QLDB_HoGa: any = {
    View: { 'code': 'QLDB_HoGa', 'action': '_view' },
    Export: { 'code': 'QLDB_HoGa', 'action': '_export' },
    Insert: { 'code': 'QLDB_HoGa', 'action': '_insert' },
    Update: { 'code': 'QLDB_HoGa', 'action': '_update' },
    Delete: { 'code': 'QLDB_HoGa', 'action': '_delete' },
  };
  public QLDB_CotKm: any = {
    View: { 'code': 'QLDB_CotKm', 'action': '_view' },
    Export: { 'code': 'QLDB_CotKm', 'action': '_export' },
    Insert: { 'code': 'QLDB_CotKm', 'action': '_insert' },
    Update: { 'code': 'QLDB_CotKm', 'action': '_update' },
    Delete: { 'code': 'QLDB_CotKm', 'action': '_delete' },
  };
  public QLDB_CotH: any = {
    View: { 'code': 'QLDB_CotH', 'action': '_view' },
    Export: { 'code': 'QLDB_CotH', 'action': '_export' },
    Insert: { 'code': 'QLDB_CotH', 'action': '_insert' },
    Update: { 'code': 'QLDB_CotH', 'action': '_update' },
    Delete: { 'code': 'QLDB_CotH', 'action': '_delete' },
  };
  public QLDB_CongTrinhHoanTra: any = {
    View: { 'code': 'QLDB_CongTrinhHoanTra', 'action': '_view' },
    Export: { 'code': 'QLDB_CongTrinhHoanTra', 'action': '_export' },
    Insert: { 'code': 'QLDB_CongTrinhHoanTra', 'action': '_insert' },
    Update: { 'code': 'QLDB_CongTrinhHoanTra', 'action': '_update' },
    Delete: { 'code': 'QLDB_CongTrinhHoanTra', 'action': '_delete' },
  };
  public QLDB_BaoCaoCongTrinhHoanTra: any = {
    View: { 'code': 'QLDB_BaoCaoCongTrinhHoanTra', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoCongTrinhHoanTra', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoCongTrinhHoanTra', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoCongTrinhHoanTra', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoCongTrinhHoanTra', 'action': '_delete' },
  };
  public QLDB_LoaiKetCauXuLy: any = {
    View: { 'code': 'QLDB_LoaiKetCauXuLy', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiKetCauXuLy', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiKetCauXuLy', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiKetCauXuLy', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiKetCauXuLy', 'action': '_delete' },
  };
  public QLDB_DinhPhanQuang: any = {
    View: { 'code': 'QLDB_DinhPhanQuang', 'action': '_view' },
    Export: { 'code': 'QLDB_DinhPhanQuang', 'action': '_export' },
    Insert: { 'code': 'QLDB_DinhPhanQuang', 'action': '_insert' },
    Update: { 'code': 'QLDB_DinhPhanQuang', 'action': '_update' },
    Delete: { 'code': 'QLDB_DinhPhanQuang', 'action': '_delete' },
  };
  public QLDB_CauDuongBo: any = {
    View: { 'code': 'QLDB_CauDuongBo', 'action': '_view' },
    Export: { 'code': 'QLDB_CauDuongBo', 'action': '_export' },
    Insert: { 'code': 'QLDB_CauDuongBo', 'action': '_insert' },
    Update: { 'code': 'QLDB_CauDuongBo', 'action': '_update' },
    Delete: { 'code': 'QLDB_CauDuongBo', 'action': '_delete' },
  };
  public QLDB_LoiRe: any = {
    View: { 'code': 'QLDB_LoiRe', 'action': '_view' },
    Export: { 'code': 'QLDB_LoiRe', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoiRe', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoiRe', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoiRe', 'action': '_delete' },
  };
  public QLDB_HamDuongBo: any = {
    View: { 'code': 'QLDB_HamDuongBo', 'action': '_view' },
    Export: { 'code': 'QLDB_HamDuongBo', 'action': '_export' },
    Insert: { 'code': 'QLDB_HamDuongBo', 'action': '_insert' },
    Update: { 'code': 'QLDB_HamDuongBo', 'action': '_update' },
    Delete: { 'code': 'QLDB_HamDuongBo', 'action': '_delete' },
  };
  public QLDB_Cong: any = {
    View: { 'code': 'QLDB_Cong', 'action': '_view' },
    Export: { 'code': 'QLDB_Cong', 'action': '_export' },
    Insert: { 'code': 'QLDB_Cong', 'action': '_insert' },
    Update: { 'code': 'QLDB_Cong', 'action': '_update' },
    Delete: { 'code': 'QLDB_Cong', 'action': '_delete' },
  };
  public QLDB_Ke: any = {
    View: { 'code': 'QLDB_Ke', 'action': '_view' },
    Export: { 'code': 'QLDB_Ke', 'action': '_export' },
    Insert: { 'code': 'QLDB_Ke', 'action': '_insert' },
    Update: { 'code': 'QLDB_Ke', 'action': '_update' },
    Delete: { 'code': 'QLDB_Ke', 'action': '_delete' },
  };
  public QLDB_RanhNuoc: any = {
    View: { 'code': 'QLDB_RanhNuoc', 'action': '_view' },
    Export: { 'code': 'QLDB_RanhNuoc', 'action': '_export' },
    Insert: { 'code': 'QLDB_RanhNuoc', 'action': '_insert' },
    Update: { 'code': 'QLDB_RanhNuoc', 'action': '_update' },
    Delete: { 'code': 'QLDB_RanhNuoc', 'action': '_delete' },
  };
  public QLDB_HoLan: any = {
    View: { 'code': 'QLDB_HoLan', 'action': '_view' },
    Export: { 'code': 'QLDB_HoLan', 'action': '_export' },
    Insert: { 'code': 'QLDB_HoLan', 'action': '_insert' },
    Update: { 'code': 'QLDB_HoLan', 'action': '_update' },
    Delete: { 'code': 'QLDB_HoLan', 'action': '_delete' },
  };
  public QLDB_DoanCocTieu: any = {
    View: { 'code': 'QLDB_DoanCocTieu', 'action': '_view' },
    Export: { 'code': 'QLDB_DoanCocTieu', 'action': '_export' },
    Insert: { 'code': 'QLDB_DoanCocTieu', 'action': '_insert' },
    Update: { 'code': 'QLDB_DoanCocTieu', 'action': '_update' },
    Delete: { 'code': 'QLDB_DoanCocTieu', 'action': '_delete' },
  };
  public QLDB_DauNoi: any = {
    View: { 'code': 'QLDB_DauNoi', 'action': '_view' },
    Export: { 'code': 'QLDB_DauNoi', 'action': '_export' },
    Insert: { 'code': 'QLDB_DauNoi', 'action': '_insert' },
    Update: { 'code': 'QLDB_DauNoi', 'action': '_update' },
    Delete: { 'code': 'QLDB_DauNoi', 'action': '_delete' },
  };
  public QLDB_MocLoGioi: any = {
    View: { 'code': 'QLDB_MocLoGioi', 'action': '_view' },
    Export: { 'code': 'QLDB_MocLoGioi', 'action': '_export' },
    Insert: { 'code': 'QLDB_MocLoGioi', 'action': '_insert' },
    Update: { 'code': 'QLDB_MocLoGioi', 'action': '_update' },
    Delete: { 'code': 'QLDB_MocLoGioi', 'action': '_delete' },
  };
  public QLDB_ThongKeDuongBo: any = {
    View: { 'code': 'QLDB_ThongKeDuongBo', 'action': '_view' },
    Export: { 'code': 'QLDB_ThongKeDuongBo', 'action': '_export' },
    Insert: { 'code': 'QLDB_ThongKeDuongBo', 'action': '_insert' },
    Update: { 'code': 'QLDB_ThongKeDuongBo', 'action': '_update' },
    Delete: { 'code': 'QLDB_ThongKeDuongBo', 'action': '_delete' },
  };
  public QLDB_LoaiHoGa: any = {
    View: { 'code': 'QLDB_LoaiHoGa', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiHoGa', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiHoGa', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiHoGa', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiHoGa', 'action': '_delete' },
  };
  public QLDB_LoaiCotBienBao: any = {
    View: { 'code': 'QLDB_LoaiCotBienBao', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiCotBienBao', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiCotBienBao', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiCotBienBao', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiCotBienBao', 'action': '_delete' },
  };
  public QLDB_LoaiCotKm: any = {
    View: { 'code': 'QLDB_LoaiCotKm', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiCotKm', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiCotKm', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiCotKm', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiCotKm', 'action': '_delete' },
  };
  public QLDB_LoaiCotH: any = {
    View: { 'code': 'QLDB_LoaiCotH', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiCotH', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiCotH', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiCotH', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiCotH', 'action': '_delete' },
  };
  public QLDB_ChieuRongCong: any = {
    View: { 'code': 'QLDB_ChieuRongCong', 'action': '_view' },
    Export: { 'code': 'QLDB_ChieuRongCong', 'action': '_export' },
    Insert: { 'code': 'QLDB_ChieuRongCong', 'action': '_insert' },
    Update: { 'code': 'QLDB_ChieuRongCong', 'action': '_update' },
    Delete: { 'code': 'QLDB_ChieuRongCong', 'action': '_delete' },
  };
  public QLDB_PhanLanDuong: any = {
    View: { 'code': 'QLDB_PhanLanDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_PhanLanDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_PhanLanDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_PhanLanDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_PhanLanDuong', 'action': '_delete' },
  };
  public QLDB_LoaiPhuongTienCam: any = {
    View: { 'code': 'QLDB_LoaiPhuongTienCam', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiPhuongTienCam', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiPhuongTienCam', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiPhuongTienCam', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiPhuongTienCam', 'action': '_delete' },
  };
  public QLDB_ToChucGiaoThong: any = {
    View: { 'code': 'QLDB_ToChucGiaoThong', 'action': '_view' },
    Export: { 'code': 'QLDB_ToChucGiaoThong', 'action': '_export' },
    Insert: { 'code': 'QLDB_ToChucGiaoThong', 'action': '_insert' },
    Update: { 'code': 'QLDB_ToChucGiaoThong', 'action': '_update' },
    Delete: { 'code': 'QLDB_ToChucGiaoThong', 'action': '_delete' },
  };
  public QLDB_LoaiLanDuong: any = {
    View: { 'code': 'QLDB_LoaiLanDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiLanDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiLanDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiLanDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiLanDuong', 'action': '_delete' },
  };
  public QLDB_KetCauHaTang: any = {
    View: { 'code': 'QLDB_KetCauHaTang', 'action': '_view' },
    Export: { 'code': 'QLDB_KetCauHaTang', 'action': '_export' },
    Insert: { 'code': 'QLDB_KetCauHaTang', 'action': '_insert' },
    Update: { 'code': 'QLDB_KetCauHaTang', 'action': '_update' },
    Delete: { 'code': 'QLDB_KetCauHaTang', 'action': '_delete' },
  };
  public QLDB_LoaiXeLuuLuong: any = {
    View: { 'code': 'QLDB_LoaiXeLuuLuong', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiXeLuuLuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiXeLuuLuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiXeLuuLuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiXeLuuLuong', 'action': '_delete' },
  };
  public QLDB_GioDoLuuLuong: any = {
    View: { 'code': 'QLDB_GioDoLuuLuong', 'action': '_view' },
    Export: { 'code': 'QLDB_GioDoLuuLuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_GioDoLuuLuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_GioDoLuuLuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_GioDoLuuLuong', 'action': '_delete' },
  };
  public QLDB_LuuLuongGiaoThong: any = {
    View: { 'code': 'QLDB_LuuLuongGiaoThong', 'action': '_view' },
    Export: { 'code': 'QLDB_LuuLuongGiaoThong', 'action': '_export' },
    Insert: { 'code': 'QLDB_LuuLuongGiaoThong', 'action': '_insert' },
    Update: { 'code': 'QLDB_LuuLuongGiaoThong', 'action': '_update' },
    Delete: { 'code': 'QLDB_LuuLuongGiaoThong', 'action': '_delete' },
  };
  public QLDB_CapDuong: any = {
    View: { 'code': 'QLDB_CapDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_CapDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_CapDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_CapDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_CapDuong', 'action': '_delete' },
  };
  public QLDB_BacDuong: any = {
    View: { 'code': 'QLDB_BacDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_BacDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_BacDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_BacDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_BacDuong', 'action': '_delete' },
  };
  public QLDB_TinhTrang_Duong: any = {
    View: { 'code': 'QLDB_TinhTrang_Duong', 'action': '_view' },
    Export: { 'code': 'QLDB_TinhTrang_Duong', 'action': '_export' },
    Insert: { 'code': 'QLDB_TinhTrang_Duong', 'action': '_insert' },
    Update: { 'code': 'QLDB_TinhTrang_Duong', 'action': '_update' },
    Delete: { 'code': 'QLDB_TinhTrang_Duong', 'action': '_delete' },
  };
  public QLDB_XepHangDuong: any = {
    View: { 'code': 'QLDB_XepHangDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_XepHangDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_XepHangDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_XepHangDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_XepHangDuong', 'action': '_delete' },
  };
  public QLDB_VatTuThuHoi: any = {
    View: { 'code': 'QLDB_VatTuThuHoi', 'action': '_view' },
    Export: { 'code': 'QLDB_VatTuThuHoi', 'action': '_export' },
    Insert: { 'code': 'QLDB_VatTuThuHoi', 'action': '_insert' },
    Update: { 'code': 'QLDB_VatTuThuHoi', 'action': '_update' },
    Delete: { 'code': 'QLDB_VatTuThuHoi', 'action': '_delete' },
  };
  public QLDB_VatTuThuHoi_ChiTiet: any = {
    View: { 'code': 'QLDB_VatTuThuHoi_ChiTiet', 'action': '_view' },
    Export: { 'code': 'QLDB_VatTuThuHoi_ChiTiet', 'action': '_export' },
    Insert: { 'code': 'QLDB_VatTuThuHoi_ChiTiet', 'action': '_insert' },
    Update: { 'code': 'QLDB_VatTuThuHoi_ChiTiet', 'action': '_update' },
    Delete: { 'code': 'QLDB_VatTuThuHoi_ChiTiet', 'action': '_delete' },
  };
  public QLDB_VatTuThuHoi_VanBan: any = {
    View: { 'code': 'QLDB_VatTuThuHoi_VanBan', 'action': '_view' },
    Export: { 'code': 'QLDB_VatTuThuHoi_VanBan', 'action': '_export' },
    Insert: { 'code': 'QLDB_VatTuThuHoi_VanBan', 'action': '_insert' },
    Update: { 'code': 'QLDB_VatTuThuHoi_VanBan', 'action': '_update' },
    Delete: { 'code': 'QLDB_VatTuThuHoi_VanBan', 'action': '_delete' },
  };
  public QLDB_VatTuThuHoi_LoaiThongKe: any = {
    View: { 'code': 'QLDB_VatTuThuHoi_LoaiThongKe', 'action': '_view' },
    Export: { 'code': 'QLDB_VatTuThuHoi_LoaiThongKe', 'action': '_export' },
    Insert: { 'code': 'QLDB_VatTuThuHoi_LoaiThongKe', 'action': '_insert' },
    Update: { 'code': 'QLDB_VatTuThuHoi_LoaiThongKe', 'action': '_update' },
    Delete: { 'code': 'QLDB_VatTuThuHoi_LoaiThongKe', 'action': '_delete' },
  };
  public QLDB_VatTuThuHoi_DonViTinh: any = {
    View: { 'code': 'QLDB_VatTuThuHoi_DonViTinh', 'action': '_view' },
    Export: { 'code': 'QLDB_VatTuThuHoi_DonViTinh', 'action': '_export' },
    Insert: { 'code': 'QLDB_VatTuThuHoi_DonViTinh', 'action': '_insert' },
    Update: { 'code': 'QLDB_VatTuThuHoi_DonViTinh', 'action': '_update' },
    Delete: { 'code': 'QLDB_VatTuThuHoi_DonViTinh', 'action': '_delete' },
  };
  public QLDB_VatTuThuHoi_LoaiVatTu: any = {
    View: { 'code': 'QLDB_VatTuThuHoi_LoaiVatTu', 'action': '_view' },
    Export: { 'code': 'QLDB_VatTuThuHoi_LoaiVatTu', 'action': '_export' },
    Insert: { 'code': 'QLDB_VatTuThuHoi_LoaiVatTu', 'action': '_insert' },
    Update: { 'code': 'QLDB_VatTuThuHoi_LoaiVatTu', 'action': '_update' },
    Delete: { 'code': 'QLDB_VatTuThuHoi_LoaiVatTu', 'action': '_delete' },
  };
  public QLDB_VatTuThuHoi_TinhTrangXuLy: any = {
    View: { 'code': 'QLDB_VatTuThuHoi_TinhTrangXuLy', 'action': '_view' },
    Export: { 'code': 'QLDB_VatTuThuHoi_TinhTrangXuLy', 'action': '_export' },
    Insert: { 'code': 'QLDB_VatTuThuHoi_TinhTrangXuLy', 'action': '_insert' },
    Update: { 'code': 'QLDB_VatTuThuHoi_TinhTrangXuLy', 'action': '_update' },
    Delete: { 'code': 'QLDB_VatTuThuHoi_TinhTrangXuLy', 'action': '_delete' },
  };
  public QLDB_LoaiNutGiaoThong: any = {
    View: { 'code': 'QLDB_LoaiNutGiaoThong', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiNutGiaoThong', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiNutGiaoThong', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiNutGiaoThong', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiNutGiaoThong', 'action': '_delete' },
  };
  public QLDB_KichThuocNutGiaoThong: any = {
    View: { 'code': 'QLDB_KichThuocNutGiaoThong', 'action': '_view' },
    Export: { 'code': 'QLDB_KichThuocNutGiaoThong', 'action': '_export' },
    Insert: { 'code': 'QLDB_KichThuocNutGiaoThong', 'action': '_insert' },
    Update: { 'code': 'QLDB_KichThuocNutGiaoThong', 'action': '_update' },
    Delete: { 'code': 'QLDB_KichThuocNutGiaoThong', 'action': '_delete' },
  };
  public QLDB_DashBoard: any = {
    View: { 'code': 'QLDB_DashBoard', 'action': '_view' },
    Export: { 'code': 'QLDB_DashBoard', 'action': '_export' },
    Insert: { 'code': 'QLDB_DashBoard', 'action': '_insert' },
    Update: { 'code': 'QLDB_DashBoard', 'action': '_update' },
    Delete: { 'code': 'QLDB_DashBoard', 'action': '_delete' },
  };
  public QLDB_ChieuCanVuon: any = {
    View: { 'code': 'QLDB_ChieuCanVuon', 'action': '_view' },
    Export: { 'code': 'QLDB_ChieuCanVuon', 'action': '_export' },
    Insert: { 'code': 'QLDB_ChieuCanVuon', 'action': '_insert' },
    Update: { 'code': 'QLDB_ChieuCanVuon', 'action': '_update' },
    Delete: { 'code': 'QLDB_ChieuCanVuon', 'action': '_delete' },
  };
  public QLDB_LoaiRanhNuoc: any = {
    View: { 'code': 'QLDB_LoaiRanhNuoc', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiRanhNuoc', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiRanhNuoc', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiRanhNuoc', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiRanhNuoc', 'action': '_delete' },
  };
  public QLDB_HoSoHoanCong: any = {
    View: { 'code': 'QLDB_HoSoHoanCong', 'action': '_view' },
    Export: { 'code': 'QLDB_HoSoHoanCong', 'action': '_export' },
    Insert: { 'code': 'QLDB_HoSoHoanCong', 'action': '_insert' },
    Update: { 'code': 'QLDB_HoSoHoanCong', 'action': '_update' },
    Delete: { 'code': 'QLDB_HoSoHoanCong', 'action': '_delete' },
  };
  public QLDB_NhaGa: any = {
    View: { 'code': 'QLDB_NhaGa', 'action': '_view' },
    Export: { 'code': 'QLDB_NhaGa', 'action': '_export' },
    Insert: { 'code': 'QLDB_NhaGa', 'action': '_insert' },
    Update: { 'code': 'QLDB_NhaGa', 'action': '_update' },
    Delete: { 'code': 'QLDB_NhaGa', 'action': '_delete' },
  };
  public QLDB_NhaChoBus: any = {
    View: { 'code': 'QLDB_NhaChoBus', 'action': '_view' },
    Export: { 'code': 'QLDB_NhaChoBus', 'action': '_export' },
    Insert: { 'code': 'QLDB_NhaChoBus', 'action': '_insert' },
    Update: { 'code': 'QLDB_NhaChoBus', 'action': '_update' },
    Delete: { 'code': 'QLDB_NhaChoBus', 'action': '_delete' },
  };
  public QLDB_BaoCaoTongHop: any = {
    View: { 'code': 'QLDB_BaoCaoTongHop', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoTongHop', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoTongHop', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoTongHop', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoTongHop', 'action': '_delete' },
  };
  public HT_QuyenQuanLy: any = {
    View: { 'code': 'HT_QuyenQuanLy', 'action': '_view' },
    Export: { 'code': 'HT_QuyenQuanLy', 'action': '_export' },
    Insert: { 'code': 'HT_QuyenQuanLy', 'action': '_insert' },
    Update: { 'code': 'HT_QuyenQuanLy', 'action': '_update' },
    Delete: { 'code': 'HT_QuyenQuanLy', 'action': '_delete' },
  };
  public HT_QuyenGiamSat: any = {
    View: { 'code': 'HT_QuyenGiamSat', 'action': '_view' },
    Export: { 'code': 'HT_QuyenGiamSat', 'action': '_export' },
    Insert: { 'code': 'HT_QuyenGiamSat', 'action': '_insert' },
    Update: { 'code': 'HT_QuyenGiamSat', 'action': '_update' },
    Delete: { 'code': 'HT_QuyenGiamSat', 'action': '_delete' },
  };
  public QLDB_DoanDuongBanGiao: any = {
    View: { 'code': 'QLDB_DoanDuongBanGiao', 'action': '_view' },
    Export: { 'code': 'QLDB_DoanDuongBanGiao', 'action': '_export' },
    Insert: { 'code': 'QLDB_DoanDuongBanGiao', 'action': '_insert' },
    Update: { 'code': 'QLDB_DoanDuongBanGiao', 'action': '_update' },
    Delete: { 'code': 'QLDB_DoanDuongBanGiao', 'action': '_delete' },
  };
  public QLDB_BaoCaoDoanDuongBanGiao: any = {
    View: { 'code': 'QLDB_BaoCaoDoanDuongBanGiao', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoDoanDuongBanGiao', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoDoanDuongBanGiao', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoDoanDuongBanGiao', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoDoanDuongBanGiao', 'action': '_delete' },
  };
  public QLDB_BaoCaoXepHangDuong: any = {
    View: { 'code': 'QLDB_BaoCaoXepHangDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoXepHangDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoXepHangDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoXepHangDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoXepHangDuong', 'action': '_delete' },
  };
  public QLDTH_NutDenTinHieu: any = {
    View: { 'code': 'QLDTH_NutDenTinHieu', 'action': '_view' },
    Export: { 'code': 'QLDTH_NutDenTinHieu', 'action': '_export' },
    Insert: { 'code': 'QLDTH_NutDenTinHieu', 'action': '_insert' },
    Update: { 'code': 'QLDTH_NutDenTinHieu', 'action': '_update' },
    Delete: { 'code': 'QLDTH_NutDenTinHieu', 'action': '_delete' },
  };
  public QLDTH_TaiSanDen: any = {
    View: { 'code': 'QLDTH_TaiSanDen', 'action': '_view' },
    Export: { 'code': 'QLDTH_TaiSanDen', 'action': '_export' },
    Insert: { 'code': 'QLDTH_TaiSanDen', 'action': '_insert' },
    Update: { 'code': 'QLDTH_TaiSanDen', 'action': '_update' },
    Delete: { 'code': 'QLDTH_TaiSanDen', 'action': '_delete' },
  };
  public QLDTH_BaoCao_KhoiLuongNutDen: any = {
    View: { 'code': 'QLDTH_BaoCao_KhoiLuongNutDen', 'action': '_view' },
    Export: { 'code': 'QLDTH_BaoCao_KhoiLuongNutDen', 'action': '_export' },
    Insert: { 'code': 'QLDTH_BaoCao_KhoiLuongNutDen', 'action': '_insert' },
    Update: { 'code': 'QLDTH_BaoCao_KhoiLuongNutDen', 'action': '_update' },
    Delete: { 'code': 'QLDTH_BaoCao_KhoiLuongNutDen', 'action': '_delete' },
  };
  public QLDTH_BaoCao_QuanLyChiTietNut: any = {
    View: { 'code': 'QLDTH_BaoCao_QuanLyChiTietNut', 'action': '_view' },
    Export: { 'code': 'QLDTH_BaoCao_QuanLyChiTietNut', 'action': '_export' },
    Insert: { 'code': 'QLDTH_BaoCao_QuanLyChiTietNut', 'action': '_insert' },
    Update: { 'code': 'QLDTH_BaoCao_QuanLyChiTietNut', 'action': '_update' },
    Delete: { 'code': 'QLDTH_BaoCao_QuanLyChiTietNut', 'action': '_delete' },
  };
  public QLDTDB_DuToanNam: any = {
    View: { 'code': 'QLDTDB_DuToanNam', 'action': '_view' },
    Export: { 'code': 'QLDTDB_DuToanNam', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_DuToanNam', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_DuToanNam', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_DuToanNam', 'action': '_delete' },
  };
  public QLDTDB_GoiThau: any = {
    View: { 'code': 'QLDTDB_GoiThau', 'action': '_view' },
    Export: { 'code': 'QLDTDB_GoiThau', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_GoiThau', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_GoiThau', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_GoiThau', 'action': '_delete' },
  };
  public QLDTDB_DanhMucHangMucChinh: any = {
    View: { 'code': 'QLDTDB_DanhMucHangMucChinh', 'action': '_view' },
    Export: { 'code': 'QLDTDB_DanhMucHangMucChinh', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_DanhMucHangMucChinh', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_DanhMucHangMucChinh', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_DanhMucHangMucChinh', 'action': '_delete' },
  };
  public QLDTDB_DanhMucHangMuc: any = {
    View: { 'code': 'QLDTDB_DanhMucHangMuc', 'action': '_view' },
    Export: { 'code': 'QLDTDB_DanhMucHangMuc', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_DanhMucHangMuc', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_DanhMucHangMuc', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_DanhMucHangMuc', 'action': '_delete' },
  };
  public QLDTDB_HangMucChinh: any = {
    View: { 'code': 'QLDTDB_HangMucChinh', 'action': '_view' },
    Export: { 'code': 'QLDTDB_HangMucChinh', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_HangMucChinh', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_HangMucChinh', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_HangMucChinh', 'action': '_delete' },
  };
  public QLDTDB_DuToanGoiThau: any = {
    View: { 'code': 'QLDTDB_DuToanGoiThau', 'action': '_view' },
    Export: { 'code': 'QLDTDB_DuToanGoiThau', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_DuToanGoiThau', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_DuToanGoiThau', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_DuToanGoiThau', 'action': '_delete' },
  };
  public QLDTDB_DuToanQuy: any = {
    View: { 'code': 'QLDTDB_DuToanQuy', 'action': '_view' },
    Export: { 'code': 'QLDTDB_DuToanQuy', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_DuToanQuy', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_DuToanQuy', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_DuToanQuy', 'action': '_delete' },
  };
  public QLDTDB_QuyetToan: any = {
    View: { 'code': 'QLDTDB_QuyetToan', 'action': '_view' },
    Export: { 'code': 'QLDTDB_QuyetToan', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_QuyetToan', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_QuyetToan', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_QuyetToan', 'action': '_delete' },
  };
  public QLDB_LoaiQuyTrinh: any = {
    View: { 'code': 'QLDB_LoaiQuyTrinh', 'action': '_view' },
    Export: { 'code': 'QLDB_LoaiQuyTrinh', 'action': '_export' },
    Insert: { 'code': 'QLDB_LoaiQuyTrinh', 'action': '_insert' },
    Update: { 'code': 'QLDB_LoaiQuyTrinh', 'action': '_update' },
    Delete: { 'code': 'QLDB_LoaiQuyTrinh', 'action': '_delete' },
  };
  public QLDB_HoSoLuuTru: any = {
    View: { 'code': 'QLDB_HoSoLuuTru', 'action': '_view' },
    Export: { 'code': 'QLDB_HoSoLuuTru', 'action': '_export' },
    Insert: { 'code': 'QLDB_HoSoLuuTru', 'action': '_insert' },
    Update: { 'code': 'QLDB_HoSoLuuTru', 'action': '_update' },
    Delete: { 'code': 'QLDB_HoSoLuuTru', 'action': '_delete' },
  };
  public HT_QuanLyVaiTro: any = {
    View: { 'code': 'HT_QuanLyVaiTro', 'action': '_view' },
    Export: { 'code': 'HT_QuanLyVaiTro', 'action': '_export' },
    Insert: { 'code': 'HT_QuanLyVaiTro', 'action': '_insert' },
    Update: { 'code': 'HT_QuanLyVaiTro', 'action': '_update' },
    Delete: { 'code': 'HT_QuanLyVaiTro', 'action': '_delete' },
  };
  public QLDB_DanhMucCauLon_KheCoDan: any = {
    View: { 'code': 'QLDB_DanhMucCauLon_KheCoDan', 'action': '_view' },
    Export: { 'code': 'QLDB_DanhMucCauLon_KheCoDan', 'action': '_export' },
    Insert: { 'code': 'QLDB_DanhMucCauLon_KheCoDan', 'action': '_insert' },
    Update: { 'code': 'QLDB_DanhMucCauLon_KheCoDan', 'action': '_update' },
    Delete: { 'code': 'QLDB_DanhMucCauLon_KheCoDan', 'action': '_delete' },
  };
  public QLDB_DanhMucCauLon_GoiCau: any = {
    View: { 'code': 'QLDB_DanhMucCauLon_GoiCau', 'action': '_view' },
    Export: { 'code': 'QLDB_DanhMucCauLon_GoiCau', 'action': '_export' },
    Insert: { 'code': 'QLDB_DanhMucCauLon_GoiCau', 'action': '_insert' },
    Update: { 'code': 'QLDB_DanhMucCauLon_GoiCau', 'action': '_update' },
    Delete: { 'code': 'QLDB_DanhMucCauLon_GoiCau', 'action': '_delete' },
  };
  public QLDB_DanhMucCauLon_KetCauCau: any = {
    View: { 'code': 'QLDB_DanhMucCauLon_KetCauCau', 'action': '_view' },
    Export: { 'code': 'QLDB_DanhMucCauLon_KetCauCau', 'action': '_export' },
    Insert: { 'code': 'QLDB_DanhMucCauLon_KetCauCau', 'action': '_insert' },
    Update: { 'code': 'QLDB_DanhMucCauLon_KetCauCau', 'action': '_update' },
    Delete: { 'code': 'QLDB_DanhMucCauLon_KetCauCau', 'action': '_delete' },
  };
  public QLDB_DanhMucCauLon_QuanLyKheCoDan: any = {
    View: { 'code': 'QLDB_DanhMucCauLon_QuanLyKheCoDan', 'action': '_view' },
    Export: { 'code': 'QLDB_DanhMucCauLon_QuanLyKheCoDan', 'action': '_export' },
    Insert: { 'code': 'QLDB_DanhMucCauLon_QuanLyKheCoDan', 'action': '_insert' },
    Update: { 'code': 'QLDB_DanhMucCauLon_QuanLyKheCoDan', 'action': '_update' },
    Delete: { 'code': 'QLDB_DanhMucCauLon_QuanLyKheCoDan', 'action': '_delete' },
  };
  QLDB_BaoCaoKheCoDan: any = {
    View: { 'code': 'QLDB_BaoCaoKheCoDan', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoKheCoDan', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoKheCoDan', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoKheCoDan', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoKheCoDan', 'action': '_delete' },
  };
  QLDTDB_HoSoPhatSinh: any = {
    View: { 'code': 'QLDTDB_HoSoPhatSinh', 'action': '_view' },
    Export: { 'code': 'QLDTDB_HoSoPhatSinh', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_HoSoPhatSinh', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_HoSoPhatSinh', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_HoSoPhatSinh', 'action': '_delete' },
  };
  QLDTDB_HoSoPhatSinh_Duyet: any = {
    View: { 'code': 'QLDTDB_HoSoPhatSinh_Duyet', 'action': '_view' },
    Export: { 'code': 'QLDTDB_HoSoPhatSinh_Duyet', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_HoSoPhatSinh_Duyet', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_HoSoPhatSinh_Duyet', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_HoSoPhatSinh_Duyet', 'action': '_delete' },
  };
  QLDTDB_QuyetToanHoSoPhatSinh: any = {
    View: { 'code': 'QLDTDB_QuyetToanHoSoPhatSinh', 'action': '_view' },
    Export: { 'code': 'QLDTDB_QuyetToanHoSoPhatSinh', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_QuyetToanHoSoPhatSinh', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_QuyetToanHoSoPhatSinh', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_QuyetToanHoSoPhatSinh', 'action': '_delete' },
  };
  QLDTDB_QuyetToanHoSoPhatSinh_Duyet: any = {
    View: { 'code': 'QLDTDB_QuyetToanHoSoPhatSinh_Duyet', 'action': '_view' },
    Export: { 'code': 'QLDTDB_QuyetToanHoSoPhatSinh_Duyet', 'action': '_export' },
    Insert: { 'code': 'QLDTDB_QuyetToanHoSoPhatSinh_Duyet', 'action': '_insert' },
    Update: { 'code': 'QLDTDB_QuyetToanHoSoPhatSinh_Duyet', 'action': '_update' },
    Delete: { 'code': 'QLDTDB_QuyetToanHoSoPhatSinh_Duyet', 'action': '_delete' },
  };
  QLDTH_LoaiTuDen: any = {
    View: { 'code': 'QLDTH_LoaiTuDen', 'action': '_view' },
    Export: { 'code': 'QLDTH_LoaiTuDen', 'action': '_export' },
    Insert: { 'code': 'QLDTH_LoaiTuDen', 'action': '_insert' },
    Update: { 'code': 'QLDTH_LoaiTuDen', 'action': '_update' },
    Delete: { 'code': 'QLDTH_LoaiTuDen', 'action': '_delete' },
  };
  QLDTH_LoaiThietBiTuDen: any = {
    View: { 'code': 'QLDTH_LoaiThietBiTuDen', 'action': '_view' },
    Export: { 'code': 'QLDTH_LoaiThietBiTuDen', 'action': '_export' },
    Insert: { 'code': 'QLDTH_LoaiThietBiTuDen', 'action': '_insert' },
    Update: { 'code': 'QLDTH_LoaiThietBiTuDen', 'action': '_update' },
    Delete: { 'code': 'QLDTH_LoaiThietBiTuDen', 'action': '_delete' },
  };
  QLDTH_TenTuDen: any = {
    View: { 'code': 'QLDTH_TenTuDen', 'action': '_view' },
    Export: { 'code': 'QLDTH_TenTuDen', 'action': '_export' },
    Insert: { 'code': 'QLDTH_TenTuDen', 'action': '_insert' },
    Update: { 'code': 'QLDTH_TenTuDen', 'action': '_update' },
    Delete: { 'code': 'QLDTH_TenTuDen', 'action': '_delete' },
  };

  QLDTH_TuDenTinHieu: any = {
    View: { 'code': 'QLDTH_TuDenTinHieu', 'action': '_view' },
    Export: { 'code': 'QLDTH_TuDenTinHieu', 'action': '_export' },
    Insert: { 'code': 'QLDTH_TuDenTinHieu', 'action': '_insert' },
    Update: { 'code': 'QLDTH_TuDenTinHieu', 'action': '_update' },
    Delete: { 'code': 'QLDTH_TuDenTinHieu', 'action': '_delete' },
  };
  BC_BaoCaoThang: any = {
    View: { 'code': 'BC_BaoCaoThang', 'action': '_view' },
    Export: { 'code': 'BC_BaoCaoThang', 'action': '_export' },
    Insert: { 'code': 'BC_BaoCaoThang', 'action': '_insert' },
    Update: { 'code': 'BC_BaoCaoThang', 'action': '_update' },
    Delete: { 'code': 'BC_BaoCaoThang', 'action': '_delete' },
  };
  QLDB_BaoCaoSuaChuaMatDuong: any = {
    View: { 'code': 'QLDB_BaoCaoSuaChuaMatDuong', 'action': '_view' },
    Export: { 'code': 'QLDB_BaoCaoSuaChuaMatDuong', 'action': '_export' },
    Insert: { 'code': 'QLDB_BaoCaoSuaChuaMatDuong', 'action': '_insert' },
    Update: { 'code': 'QLDB_BaoCaoSuaChuaMatDuong', 'action': '_update' },
    Delete: { 'code': 'QLDB_BaoCaoSuaChuaMatDuong', 'action': '_delete' },
  };
  QLDTH_DM_CumDen: any = {
    View: { 'code': 'QLDTH_DM_CumDen', 'action': '_view' },
    Export: { 'code': 'QLDTH_DM_CumDen', 'action': '_export' },
    Insert: { 'code': 'QLDTH_DM_CumDen', 'action': '_insert' },
    Update: { 'code': 'QLDTH_DM_CumDen', 'action': '_update' },
    Delete: { 'code': 'QLDTH_DM_CumDen', 'action': '_delete' },
  };
  QLDTH_HoGaDen: any = {
    View: { 'code': 'QLDTH_HoGaDen', 'action': '_view' },
    Export: { 'code': 'QLDTH_HoGaDen', 'action': '_export' },
    Insert: { 'code': 'QLDTH_HoGaDen', 'action': '_insert' },
    Update: { 'code': 'QLDTH_HoGaDen', 'action': '_update' },
    Delete: { 'code': 'QLDTH_HoGaDen', 'action': '_delete' },
  };
  QLDTH_DM_LoaiCap: any = {
    View: { 'code': 'QLDTH_DM_LoaiCap', 'action': '_view' },
    Export: { 'code': 'QLDTH_DM_LoaiCap', 'action': '_export' },
    Insert: { 'code': 'QLDTH_DM_LoaiCap', 'action': '_insert' },
    Update: { 'code': 'QLDTH_DM_LoaiCap', 'action': '_update' },
    Delete: { 'code': 'QLDTH_DM_LoaiCap', 'action': '_delete' },
  };
  QLDTH_DuongCap: any = {
    View: { 'code': 'QLDTH_DuongCap', 'action': '_view' },
    Export: { 'code': 'QLDTH_DuongCap', 'action': '_export' },
    Insert: { 'code': 'QLDTH_DuongCap', 'action': '_insert' },
    Update: { 'code': 'QLDTH_DuongCap', 'action': '_update' },
    Delete: { 'code': 'QLDTH_DuongCap', 'action': '_delete' },
  };
  QLDB_DM_LoaiCotMoc: any = {
    View: { 'code': 'QLDB_DM_LoaiCotMoc', 'action': '_view' },
    Export: { 'code': 'QLDB_DM_LoaiCotMoc', 'action': '_export' },
    Insert: { 'code': 'QLDB_DM_LoaiCotMoc', 'action': '_insert' },
    Update: { 'code': 'QLDB_DM_LoaiCotMoc', 'action': '_update' },
    Delete: { 'code': 'QLDB_DM_LoaiCotMoc', 'action': '_delete' },
  };
  QLDB_HanhLangATGT: any = {
    View: { 'code': 'QLDB_HanhLangATGT', 'action': '_view' },
    Export: { 'code': 'QLDB_HanhLangATGT', 'action': '_export' },
    Insert: { 'code': 'QLDB_HanhLangATGT', 'action': '_insert' },
    Update: { 'code': 'QLDB_HanhLangATGT', 'action': '_update' },
    Delete: { 'code': 'QLDB_HanhLangATGT', 'action': '_delete' },
  };
  public AdminAccount: any = {
    Create: { action: '_create' },
    View: { action: '_view' },
    Update: { action: '_update' },
    Delete: { action: '_delete' },
    AdminAccount: 'AdminAccount',
    Login: 'Admin_Login',
    DataLogin: { username: 'admin@gt247.vn', password: '123123' }
  }
  public userInfo: any = {}
  public navData: any;
  constructor(
    private translateService: TranslateService,
    private toastrService: ToastrService,
    private httpService: HttpService,
  ) { }

  setInitState() {
    this.translateService.addLangs(['en', 'vi']);
    const browserLang = (this.translate.getBrowserLang().includes('vi')) ? 'en' : 'vi';
    this.setLang(browserLang);
  }

  setLang(lang: string) {
    this.translateService.onLangChange.pipe(take(1)).subscribe(result => {
      this.language$.next(result);
    });
    this.translateService.use(lang);
  }
  bitToValue = (value) => {
    if (value == null) {
      return 0;
    } else if (value.data) {
      return value.data[0];
    } else {
      return value ? 1 : 0;
    }
  }
  trans(data: string, params: object = {}) {
    if (Object.keys(params).length) {
      for (const key in params) {
        params[key] = `${params[key]}`.toLowerCase();
      }
    }
    return this.translate.instant(data, params);
  }
  transAll(data: string, params: object = {}) {
    if (Object.keys(params).length) {
      for (const key in params) {
        params[key] = this.trans(params[key]).toLowerCase();
      }
    }
    return this.translate.instant(data, params);
  }
  messageRes(message: any) {
    this.toastrService.success(this.translate.instant(message));
  }
  messageErr(res: any) {
    if (res.error && res.error.message) {
      this.toastrService.error(this.translate.instant(res.error.message));
    } else if (res.error) {
      this.toastrService.error(this.translate.instant(res.error));
    }
  }
  messageErr_Text(res: any) {
    this.toastrService.error(this.translate.instant(res));
  }
  dateToStringddMMYYYY(date: any): string {

    if (date) {
      let d = new Date(date).getDate();
      let ds = d < 10 ? '0' + d : d;
      let m = new Date(date).getMonth() + 1;
      let ms = m < 10 ? '0' + m : m;
      let y = new Date(date).getFullYear();
      return ds + '/' + ms + '/' + y;
    } else {
      return null;
    }
  }
  dateToStringYYYYMMDD(date: any): string {

    if (date) {
      let d = new Date(date).getDate();
      let ds = d < 10 ? '0' + d : d;
      let m = new Date(date).getMonth() + 1;
      let ms = m < 10 ? '0' + m : m;
      let y = new Date(date).getFullYear();
      return y + '-' + ms + '-' + ds;
    } else {
      return null;
    }
  }
  datetoStringDateTime(date: any): string {
    if (date) {
      let d = new Date(date).getDate();
      let ds = d < 10 ? '0' + d : d;
      let m = new Date(date).getMonth() + 1;
      let ms = m < 10 ? '0' + m : m;
      let y = new Date(date).getFullYear();
      let h = new Date(date).getUTCHours();
      let mm = new Date(date).getMinutes();
      let mms = mm < 10 ? '0' + mm : mm;
      return h + ':' + mms + ' ' + y + '-' + ms + '-' + ds;
    } else {
      return null;
    }
  }
  insertSystemLog(data: any, permission: any, action: any): Observable<any> {
    return this.httpService.postToHrm('gt247/system-log/insert',
      {
        ...data,
        codeSystem: 'rbms',
        id_account: this.userInfo.portal_account_id,
        id_employee: this.userInfo.portal_account_id,
        username: this.userInfo.username,

      }
      , permission, action);
  }

  createLog(type: any, subType: any, preValue: any, newValue: any, message: any, permissionCode: any) {
    this.insertSystemLog({
      "action": this.actionType[type],
      "permissionCode": permissionCode,
      "subSystem": this.subSystemType[subType],
      "preValue": preValue,
      "newValue": newValue,
      "description": message
    }, this.AdminAccount.Login, this.AdminAccount.View
    ).subscribe()

  }
  getNgayDauQuy(quy, nam) {
    let thang = '10';
    if (quy === 1) {
      thang = '01';
    } else if (quy === 2) {
      thang = '04';
    } else if (quy === 3) {
      thang = '07';
    } else {
      thang = '10';
    }
    return nam + '/' + thang + '/01';
  }
  getNgayCuoiThang(thang, nam) {
    let d = new Date(nam, thang, 0)
    return nam + '/' + thang.toString().padStart(2, "0") + '/' + d.getDate();
  }
  hideClassDialog(dialogRef: MatDialogRef<any>) {
    dialogRef.addPanelClass('hidden');
    dialogRef.removePanelClass('show');
  }
  showClassDialog(dialogRef: MatDialogRef<any>) {
    dialogRef.addPanelClass('show');
    dialogRef.removePanelClass('hidden');
  }
  calLyTrinh(lyTrinh_khoangCach) {
    let soKm = Math.floor(lyTrinh_khoangCach / 1000);
    let soM = lyTrinh_khoangCach % 1000
    return `Km${soKm}+${soM.toString().padStart(3, '0')}`;
  }
  anyToDate(data: any, outFormat: string = 'YYYY-MM-DD', inFormat: string = 'DD/MM/YYYY') {
    let result = null;
    if (Number.isInteger(data)) {
      result = moment(new Date((data - 25569) * 86400 * 1000)).format(outFormat);
    } else if (typeof data == 'string' && data.length == 10) {
      result = moment(data, inFormat, true).isValid() ? moment(data, inFormat).format(outFormat) : null;
    } else if (!isNaN(Date.parse(data))) {
      result = moment(data).format(outFormat);
    }
    return result;
  }
  getPermissionObject(code: string): PermissionHttp {
    return {
      View: { code, action: '_view' },
      Insert: { code, action: '_insert' },
      Update: { code, action: '_update' },
      Delete: { code, action: '_delete' },
      Export: { code, action: '_export' },
    }
  }
}
